import React, { useState, useEffect, useRef } from 'react';
import {
  ArrowLeft,
  MapPin,
  CheckCircle,
  AlertCircle,
  Loader,
  Save,
  Edit2,
  X,
  Calculator,
  TrendingUp,
  Users,
  DollarSign,
  Calendar,
  FileText,
  Settings,
  Award,
  Banknote,
  Building,
  TreePine,
  Wheat,
  Droplets,
  Home,
  Cable,
  Zap,
  Package,
  Search,
  Filter,
  Download,
  Eye,
  ChevronDown,
  ChevronUp,
  Info,
  RefreshCw,
  ChevronRight,
  UserCheck,
  Globe
} from 'lucide-react';
import apiService from '../config';
import { toast } from 'react-toastify';
import { Send } from 'lucide-react';
import { useLanguage } from "../StoreContext/LanguageContext";

// Main Compensation Management Component
const HighwayConcernValuer = ({ onBack }) => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const userRole = userData?.user_role;

  const roleToAgencyMap = {
    21: "agriculture",       // Valuer-Agriculture
    23: "consulting_agent",  // Valuer-Other
    24: "forest", // Valuer-Forest
    // Data Entry
    14: "data_entry"
  };

  const [selectedAgency, setSelectedAgency] = useState(roleToAgencyMap[userRole] || "");
  const [showAgencyModal, setShowAgencyModal] = useState(false); // 🚫 skip modal

  // Location data states
  const [districts, setDistricts] = useState([]);
  const [availableTalukas, setAvailableTalukas] = useState([]);
  const [availableVillages, setAvailableVillages] = useState([]);

  // Filter states
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedTaluka, setSelectedTaluka] = useState('');
  const [selectedVillage, setSelectedVillage] = useState('');

  // NEW: Filter mode and panel states
  const [filterMode, setFilterMode] = useState('all');
  const [showFilterPanel, setShowFilterPanel] = useState(true);

  // Data states
  const [compensationData, setCompensationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingTalukas, setLoadingTalukas] = useState(false);
  const [loadingVillages, setLoadingVillages] = useState(false);

  // UI states
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');

  // Edit states - SIMPLE AND CLEAN
  const [editingCompensation, setEditingCompensation] = useState(false);
  const [editError, setEditError] = useState(null);

  // Current project and proposal info
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProposalId, setCurrentProposalId] = useState(null);
  const [proposalNo, setProposalNo] = useState('')

  // SIMPLE INLINE EDITING STATES
  const [editingRowId, setEditingRowId] = useState(null);
  const [editingValues, setEditingValues] = useState({});

  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [selectedOwnerIds, setSelectedOwnerIds] = useState([]);
  const [tableData, setTableData] = useState([]);

  const hasValidLocationSelection = selectedDistrict;
  const canShowData = filterMode === 'all' || (filterMode === 'location' && hasValidLocationSelection);
  const ownerIds = tableData.map(item => item.land_owner_id);
  const [usersLao, setUsersLao] = useState([]);
  const [usersSamanvay, setUsersSamanvay] = useState([]);
  const [usersAgency, setUsersAgency] = useState([]);
  // Show/hide modals
  const [showSendToLAOModal, setShowSendToLAOModal] = useState(false);
  const [showSendToAgencyModal, setShowSendToAgencyModal] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  // const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const [selectedUser, setSelectedUser] = useState('');
  const [remarks, setRemarks] = useState('');
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [sendingToLAO, setSendingToLAO] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [proposalId, setProposalId] = useState(null);
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [selectedSamanvayOfficer, setSelectedSamanvayOfficer] = useState('');
  const [samanvayOptions, setSamanvayOptions] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [onConfirmAction, setOnConfirmAction] = useState(null);
  const [isCompensationButtonDisabled, setIsCompensationButtonDisabled] = useState(false);
  const [isCompensationButtonClicked, setIsCompensationButtonClicked] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  // Document Viewer states
  const [showDocumentViewer, setShowDocumentViewer] = useState(false);
  const [fileUrlToView, setFileUrlToView] = useState('');
  const [isPDFToView, setIsPDFToView] = useState(false);

  const printRef = useRef(null);

  // const userRole = userData?.usr_role;
  const USER_ROLES = {
    SURVEYOR: 7,
    LAO: 3,
    DSLR: 15,
    AGENCY: 21,
    SAMANVAY: 6,
    DATA_ENTRY: 14
  };

  // User data state
  const [users, setUsers] = useState([]);

  // Function to get current proposal ID from localStorage
  const getCurrentProposalId = () => {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const proposalId = userData?.data?.default_proposal ||
      userData?.data?.proposal_id ||
      userData?.default_proposal ||
      userData?.proposal_id ||
      localStorage.getItem('currentProposalId') ||
      null;

    console.log("userData", userData);

    const finalProposalId = proposalId ? parseInt(proposalId) : null;
    if (finalProposalId) {
      console.log('📋 Current proposal ID from localStorage:', finalProposalId);
    }
    return finalProposalId;
  };

  // Handle agency selection from modal
  const handleAgencySelect = (agency) => {
    setSelectedAgency(agency);
    setShowAgencyModal(false);
  };

  const getAgencyInfo = () => {
    const agencyMap = {
      agriculture: { label: <span>{translations[language].agriculture}</span>, icon: <Wheat className="w-5 h-5" />, color: 'text-green-600' },
      consulting_agent: { label: <span>{translations[language].Agother}</span>, icon: <Building className="w-5 h-5" />, color: 'text-blue-600' },
      forest: { label: <span>{translations[language].forest}</span>, icon: <TreePine className="w-5 h-5" />, color: 'text-emerald-600' },
      vc: { label: <span>{translations[language].VillageCouncil}</span>, icon: <Users className="w-5 h-5" />, color: 'text-purple-600' }
    };
    return agencyMap[selectedAgency] || {};
  };

  // Function to get visible columns based on selected agency
  const getVisibleColumns = () => {
    switch (selectedAgency) {
      case 'agriculture':
        return {
          tree: true,
          borewell: false,
          home: false,
          pipeline: false,
          tinShed: false,
          wire: false,
          well: false,
          otherAsset: false,
          farmpond: false,
          count: true
        };
      case 'forest':
        return {
          tree: true,
          borewell: false,
          home: false,
          pipeline: false,
          tinShed: false,
          wire: false,
          well: false,
          otherAsset: false,
          farmpond: false,
          count: true
        };
      case 'consulting_agent':
        return {
          tree: false,
          borewell: true,
          home: true,
          pipeline: true,
          tinShed: true,
          wire: true,
          well: true,
          otherAsset: true,
          farmpond: true,

        };
      // Data Entry
      case 'data_entry':
        return {
          tree: true,
          borewell: true,
          home: true,
          pipeline: true,
          tinShed: true,
          wire: true,
          well: true,
          otherAsset: true,
          farmpond: true,
          count: true,
          crop: true,
          structure: true,
          waterBody: true,
          land: true,
        };
      default:
        return {
          tree: true,
          borewell: true,
          home: true,
          pipeline: true,
          tinShed: true,
          wire: true,
          well: true,
          otherAsset: true,
          farmpond: true,
        };
    }
  };

  const handleSendToLao = async () => {
    const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
    const projectId = selectedProject?.id || selectedProject?.project_id;
    const proposalId = currentProposalId;
    const ownerIdString = tableData
      .map(record => record.landOwnerId)
      .filter(Boolean)
      .join(',');

    console.log("📦 tableData length:", tableData.length);
    console.log("📦 ownerIdString:", ownerIdString);
    console.log("📦 tableData sample:", tableData.slice(0, 3));


    if (!selectedUser || !selectedDocument) {
      toast.warning('Please select a user and upload a document.');
      return;
    }

    if (!ownerIdString || ownerIdString.trim() === '') {
      toast.warning('No records found to send.');
      return;
    }

    setSendingToLAO(true);
    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarks);
      formData.append('usr_id', selectedUser);
      formData.append('document', selectedDocument);
      formData.append('owner_id', ownerIdString);

      const response = await apiService.postHighwayTrackingCompensation(formData);
      console.log('Send to LAO response:', response);

      if (response.status === 200) {
        toast.success('Successfully sent back to LAO Officer!');
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 3000);

        setShowSendToLAOModal(false);
        setSelectedUser('');
        setRemarks('Approved');
        setSelectedDocument(null);

        setIsCompensationButtonClicked(true); // 🔴 turn button red (not disable)
      } else {
        toast.error('Failed to send back to LAO Officer. Please try again.');
      }
    } catch (error) {
      console.error('Error sending to LAO:', error);
      toast.error('Error while sending back to LAO. Please try again.');
    } finally {
      setSendingToLAO(false);
    }
  };

  useEffect(() => {
    const fetchButtonState = async () => {
      try {
        if (currentProjectId && currentProposalId) {
          const res = await apiService.getHighwayCompensationButton(currentProjectId, currentProposalId, 'Compensation');
          if (res.status === 200 && Array.isArray(res.data) && res.data.length > 0) {
            setIsCompensationButtonClicked(true); // make it red
          }
        }
      } catch (err) {
        console.error("Error checking button state:", err);
      }
    };
    fetchButtonState();
  }, [currentProjectId, currentProposalId]);

  // Get selected project and proposal from localStorage
  useEffect(() => {
    const getSelectedProjectAndProposal = () => {
      try {
        // Get project ID
        const storedProject = localStorage.getItem('selectedProject');
        if (storedProject) {
          const project = JSON.parse(storedProject);
          const projectIdFromStorage = project.id || project.project_id;
          if (projectIdFromStorage) {
            setCurrentProjectId(projectIdFromStorage);
            console.log('📋 Current project ID from localStorage:', projectIdFromStorage);
          }
        }

        // Get proposal ID
        const proposalId = getCurrentProposalId();
        if (proposalId) {
          setCurrentProposalId(proposalId);
          console.log('📋 Current proposal ID set in state:', proposalId);
        } else {
          console.log('📋 No proposal ID found in localStorage');
        }
      } catch (error) {
        console.error('Error reading selected project and proposal:', error);
      }
    };

    getSelectedProjectAndProposal();
    window.addEventListener('storage', getSelectedProjectAndProposal);
    return () => window.removeEventListener('storage', getSelectedProjectAndProposal);
  }, []);

  // Add this function after getCurrentProposalId function
  const fetchProposalNo = async () => {
    if (!currentProjectId || !currentProposalId) return;

    try {
      const result = await apiService.getHighwayProposalPublish(currentProjectId, currentProposalId);

      if (result.status === 200 && result.data) {
        const bhusampadan_no = result.data.section_11_bhusampadan_no || result.data.acquisition_proposal_no;
        setProposalNo(bhusampadan_no);
        console.log('📋 Proposal No (Bhusampadan):', bhusampadan_no);
      }
    } catch (error) {
      console.error('Error fetching proposal number:', error);
    }
  };

  // Add this useEffect after your existing useEffects
  useEffect(() => {
    if (currentProjectId && currentProposalId) {
      fetchProposalNo();
    }
  }, [currentProjectId, currentProposalId]);

  // Load districts on component mount (only if agency is selected)
  useEffect(() => {
    if (selectedAgency) {
      loadDistricts();
    }
  }, [selectedAgency]);

  // Load talukas when district changes
  useEffect(() => {
    if (selectedDistrict) {
      loadTalukas();
    } else {
      setAvailableTalukas([]);
      setSelectedTaluka('');
      setSelectedVillage('');
      setAvailableVillages([]);
    }
  }, [selectedDistrict]);

  // Load villages when taluka changes
  useEffect(() => {
    if (selectedTaluka && selectedDistrict) {
      loadVillages();
    } else {
      setAvailableVillages([]);
      setSelectedVillage('');
    }
  }, [selectedTaluka, selectedDistrict]);

  // Load compensation data based on filter mode
  useEffect(() => {
    if (filterMode === 'all' && currentProjectId && currentProposalId) {
      loadCompensationData();
    }
  }, [filterMode, currentProjectId, currentProposalId]);

  useEffect(() => {
    if (filterMode === 'location' && currentProjectId && currentProposalId && selectedDistrict) {

      loadCompensationData();
    } else if (filterMode === 'location' && (!currentProjectId || !currentProposalId || !selectedDistrict)) {
      setCompensationData([]);
    }
  }, [filterMode, selectedDistrict, selectedTaluka, selectedVillage, currentProjectId, currentProposalId]);

  // Add this useEffect to open filter panel by default
  useEffect(() => {
    setShowFilterPanel(true);
  }, []);

  // Updated loadDistricts with auto-selection from selectedProposal
  const loadDistricts = async () => {
    try {
      setLoadingDistricts(true);
      const response = await apiService.getDistricts();

      const districtsData = response.data || response || [];
      const districtsArray = Array.isArray(districtsData) ? districtsData : [];

      setDistricts(districtsArray);

      // Auto-select district if selectedProposal has it and current selection is empty
      const proposalStr = localStorage.getItem('selectedProposal');
      if (proposalStr) {
        try {
          const proposal = JSON.parse(proposalStr);
          const desired = proposal.dist_name || proposal.distName;
          if (desired && !selectedDistrict) {
            const found = districtsArray.find(d =>
              d.dist_name === desired || d.name === desired || d.eng_dist_name === desired
            );
            setSelectedDistrict(found ? (found.dist_name || found.id) : desired);
          }
        } catch (e) {
          console.error('Error parsing selectedProposal in loadDistricts:', e);
        }
      }
    } catch (error) {
      console.error('Error loading districts:', error);
      setError('Failed to load districts: ' + error.message);
      setDistricts([]);
    } finally {
      setLoadingDistricts(false);
    }
  };

  // Updated loadTalukas with auto-selection from selectedProposal
  const loadTalukas = async () => {
    try {
      setLoadingTalukas(true);
      setAvailableTalukas([]);
      const selectedDistrictObj = districts.find(d =>
        d.dist_name === selectedDistrict || d.district_name === selectedDistrict
      );

      if (!selectedDistrictObj) {
        console.warn('Selected district object not found:', selectedDistrict);
        return;
      }

      const distNo = selectedDistrictObj.dist_name;
      const response = await apiService.getTalukas(distNo);

      const talukasData = response.data || response || [];
      const talukasArray = Array.isArray(talukasData) ? talukasData : [];

      setAvailableTalukas(talukasArray);

      // Auto-select taluka if selectedProposal has it and current selection is empty
      const proposalStr = localStorage.getItem('selectedProposal');
      if (proposalStr) {
        try {
          const proposal = JSON.parse(proposalStr);
          const desiredTaluka = proposal.taluka_name || proposal.talukaName;
          if (desiredTaluka && !selectedTaluka) {
            const found = talukasArray.find(t =>
              t.taluka_name === desiredTaluka || t.tehsil_name === desiredTaluka || t.eng_tehsil_name === desiredTaluka
            );
            setSelectedTaluka(found ? (found.taluka_name || found.id) : desiredTaluka);
          }
        } catch (e) {
          console.error('Error parsing selectedProposal in loadTalukas:', e);
        }
      }
    } catch (error) {
      console.error('Error loading talukas:', error);
      setError('Failed to load talukas: ' + error.message);
      setAvailableTalukas([]);
    } finally {
      setLoadingTalukas(false);
    }
  };

  // Updated loadVillages with auto-selection from selectedProposal
  const loadVillages = async () => {
    try {
      setLoadingVillages(true);
      setAvailableVillages([]);
      const selectedDistrictObj = districts.find(d =>
        d.dist_name === selectedDistrict || d.district_name === selectedDistrict
      );
      const selectedTalukaObj = availableTalukas.find(t =>
        t.taluka_name === selectedTaluka || t.tehsil_name === selectedTaluka
      );

      if (!selectedDistrictObj || !selectedTalukaObj) {
        console.warn('District or Taluka object not found:', { selectedDistrict, selectedTaluka });
        return;
      }

      const distNo = selectedDistrictObj.dist_name;
      const tehsilNo = selectedTalukaObj.taluka_name || selectedTalukaObj.tehsil_name;

      const response = await apiService.getVillages(distNo, tehsilNo);

      const villagesData = response.data || response || [];
      const villagesArray = Array.isArray(villagesData) ? villagesData : [];

      setAvailableVillages(villagesArray);

      // Auto-select village if selectedProposal has it and current selection is empty
      const proposalStr = localStorage.getItem('selectedProposal');
      if (proposalStr) {
        try {
          const proposal = JSON.parse(proposalStr);
          const desiredVillage = proposal.village_name || proposal.villageName;
          if (desiredVillage && !selectedVillage) {
            const found = villagesArray.find(v =>
              v.village_name === desiredVillage ||
              v.Village_Name === desiredVillage ||
              v.eng_village_name === desiredVillage ||
              v.name === desiredVillage
            );
            setSelectedVillage(found ? (found.village_name || found.id || found.village_id) : desiredVillage);
          }
        } catch (e) {
          console.error('Error parsing selectedProposal in loadVillages:', e);
        }
      }
    } catch (error) {
      console.error('Error loading villages:', error);
      setError('Failed to load villages: ' + error.message);
      setAvailableVillages([]);
    } finally {
      setLoadingVillages(false);
    }
  };

  // Updated handleDistrictChange to reset dependent fields ONLY (no immediate load)
  const handleDistrictChange = (e) => {
    const value = e.target.value;
    setSelectedDistrict(value);
    setSelectedTaluka('');
    setAvailableTalukas([]);
    setSelectedVillage('');
    setAvailableVillages([]);
    // Remove the if-else block here - let useEffect handle loading/clearing
  };

  // Updated handleTalukaChange to reset village ONLY (no immediate load)
  const handleTalukaChange = (e) => {
    const value = e.target.value;
    setSelectedTaluka(value);
    setSelectedVillage('');
    setAvailableVillages([]);
    // Remove the if-else block here - let useEffect handle loading/clearing
  };

  // Updated handleVillageChange to refresh ONLY via useEffect (no immediate load)
  const handleVillageChange = (e) => {
    const value = e.target.value;
    setSelectedVillage(value);
    // Remove the if-else block here - let useEffect handle loading/clearing
  };

  const { language, translations } = useLanguage();

  const loadCompensationData = async () => {
    try {
      setLoading(true);
      setError(null);

      const proposalId = currentProposalId || getCurrentProposalId();

      console.log('🔍 Loading compensation data with:', {
        filterMode,
        district: selectedDistrict,
        taluka: selectedTaluka,
        village: selectedVillage,
        projectId: currentProjectId,
        proposalId: proposalId
      });

      let response;

      if (filterMode === 'all') {
        // Load all compensation data for the project (no location filter)
        console.log('🔍 Loading ALL compensation data for project:', currentProjectId);
        response = await apiService.getHighwayAgencyCompensation(currentProjectId, proposalId);
      } else if (filterMode === 'location') {
        // Load compensation data based on current selection level
        console.log('🔍 Loading location-based compensation data');

        // Build parameters based on current selections only
        const params = [currentProjectId, proposalId];

        // Add district if selected
        if (selectedDistrict) {
          params.push(selectedDistrict);
          console.log('🏙️ District selected:', selectedDistrict);

          // Add taluka only if district is selected AND taluka is selected
          if (selectedTaluka) {
            params.push(selectedTaluka);
            console.log('🏘️ Taluka selected:', selectedTaluka);

            // Add village only if district, taluka are selected AND village is selected
            if (selectedVillage) {
              params.push(selectedVillage);
              console.log('🏡 Village selected:', selectedVillage);
            }
          }
        }

        // Make API call with dynamic parameters
        response = await apiService.getHighwayAgencyCompensation(...params);
      }

      if (response && (response.status === 200 || response.data)) {
        let dataArray = [];

        if (response.data && response.data.data && Array.isArray(response.data.data)) {
          dataArray = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          dataArray = response.data;
        } else if (Array.isArray(response)) {
          dataArray = response;
        } else if (response.data && !Array.isArray(response.data)) {
          dataArray = [response.data];
        } else if (response && !response.data) {
          dataArray = [response];
        }

        const transformedData = transformBackendData(dataArray);
        // ✅ Agency-wise filter
        const ownersWithAssets = transformedData.filter(owner => {
          const raw = owner.rawData || {};
          const hasArrayData = (arr) => Array.isArray(arr) && arr.length > 0;

          // AGRICULTURE → show only fruit trees (फळझाडे)
          if (selectedAgency === 'agriculture') {
            const hasFruitTrees =
              hasArrayData(raw.tree) &&
              raw.tree.some(t => t.tree_type_name1 === 'फळझाडे');
            return hasFruitTrees;
          }

          // FOREST → show only forest trees (वनझाडे)
          if (selectedAgency === 'forest') {
            const hasForestTrees =
              hasArrayData(raw.tree) &&
              raw.tree.some(t => t.tree_type_name1 === 'वनझाडे');
            return hasForestTrees;
          }

          // CONSULTING_AGENT (Other) → show only non-tree assets
          // Data Entry
          // if (selectedAgency === 'consulting_agent') {
          if (selectedAgency === 'consulting_agent' || selectedAgency === 'data_entry') {
            return (
              hasArrayData(raw.home) ||
              hasArrayData(raw["tinshed/godown"]) ||
              hasArrayData(raw.wirefencing) ||
              hasArrayData(raw.farmpond) ||
              hasArrayData(raw.well) ||
              hasArrayData(raw.pipeline) ||
              hasArrayData(raw.borewell) ||
              hasArrayData(raw.other)
            );
          }

          // Default fallback: show if any valid asset present
          return (
            hasArrayData(raw.tree) ||
            hasArrayData(raw.home) ||
            hasArrayData(raw["tinshed/godown"]) ||
            hasArrayData(raw.wirefencing) ||
            hasArrayData(raw.farmpond) ||
            hasArrayData(raw.well) ||
            hasArrayData(raw.pipeline) ||
            hasArrayData(raw.borewell) ||
            hasArrayData(raw.other)
          );
        });

        setCompensationData(ownersWithAssets);
        setTableData(ownersWithAssets);
        console.log(`✅ Showing ${ownersWithAssets.length} owner(s) for agency:`, selectedAgency);


      } else {
        setCompensationData([]);
        setError('Invalid response structure from server');
      }
    } catch (error) {
      console.error('Error loading compensation data:', error);
      setCompensationData([]);

      if (error.message.includes('404') || error.message.includes('Not Found')) {
        // Build location info based on current selection level
        let locationInfo = 'Project-wide data';
        if (filterMode === 'location') {
          if (selectedDistrict && selectedTaluka && selectedVillage) {
            locationInfo = `Village: ${selectedVillage} (${selectedTaluka}, ${selectedDistrict})`;
          } else if (selectedDistrict && selectedTaluka) {
            locationInfo = `Taluka: ${selectedTaluka} (${selectedDistrict})`;
          } else if (selectedDistrict) {
            locationInfo = `District: ${selectedDistrict}`;
          } else {
            locationInfo = 'Project-wide data (no location selected)';
          }
        }

        const projectInfo = `Project ID: ${currentProjectId}`;
        const proposalInfo = currentProposalId ? ` | Proposal ID: ${currentProposalId}` : '';
        setError(`No compensation records found for ${locationInfo} under ${projectInfo}${proposalInfo}`);
      } else if (error.response?.status === 500) {
        setError('Server error occurred. Please try again later.');
      } else {
        setError('Failed to load compensation data: ' + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  // Transform backend data to component structure - FIXED VERSION
  const transformBackendData = (backendData) => {
    return backendData.map(item => {
      const ownerId = item.land_owner_id;
      console.log("owner id :", ownerId);

      let treeCount = parseInt(item.no_of_tree ?? 0) || 0;
      if (selectedAgency === 'agriculture') {
        treeCount = (item.tree || []).filter(t => t.tree_type_name1 === 'फळझाडे').length;
      } else if (selectedAgency === 'forest') {
        treeCount = (item.tree || []).filter(t => t.tree_type_name1 === 'वनझाडे').length;
      }
      let homeCount = parseInt(item.no_of_home ?? 0) || 0;
      if (item.home && Array.isArray(item.home)) {
        homeCount = item.home.length;
      }
      let tinShedCount = parseInt(item.no_of_tinshed ?? 0) || 0;
      if (item['tinshed/godown'] && Array.isArray(item['tinshed/godown'])) {
        tinShedCount = item['tinshed/godown'].length;
      }
      let wireCount = parseInt(item.no_of_wirefencing ?? 0) || 0;
      if (item.wirefencing && Array.isArray(item.wirefencing)) {
        wireCount = item.wirefencing.length;
      }
      let borewellCount = parseInt(item.no_of_borewell ?? 0) || 0;
      if (item.borewell && Array.isArray(item.borewell)) {
        borewellCount = item.borewell.length;
      }
      let pipelineCount = parseInt(item.no_of_pipeline ?? 0) || 0;
      if (item.pipeline && Array.isArray(item.pipeline)) {
        pipelineCount = item.pipeline.length;
      }
      let otherAssetCount = parseInt(item.no_of_other_asset ?? 0) || 0;
      if (item.other && Array.isArray(item.other)) {
        otherAssetCount = item.other.length;
      }
      let wellCount = parseInt(item.no_of_well ?? 0) || 0;
      if (item.well && Array.isArray(item.well)) {
        wellCount = item.well.length;
      }
      let farmPondCount = parseInt(item.no_of_fram_pound ?? 0) || 0;
      if (item.farmpond && Array.isArray(item.farmpond)) {
        farmPondCount = item.farmpond.length;
      }

      const structureCount = parseInt(item.no_of_structure ?? 0) || 0;
      const cropCount = parseInt(item.no_of_crop ?? 0) || 0;
      const waterBodyCount = parseInt(item.no_of_water_body ?? 0) || 0;

      const wellCompensationAmount = parseFloat(item.well_amount ?? 0) || 0;
      const structureCompensationAmount = parseFloat(item.structure_amount ?? 0) || 0;
      const treeCompensationAmount = parseFloat(item.tree_amount ?? 0) || 0;
      const cropCompensationAmount = parseFloat(item.crop_amount ?? 0) || 0;
      const waterBodyCompensationAmount = parseFloat(item.water_body_amount ?? 0) || 0;
      const borewellCompensationAmount = parseFloat(item.borewell_amount ?? 0) || 0;
      const homeCompensationAmount = parseFloat(item.home_amount ?? 0) || 0;
      const pipelineCompensationAmount = parseFloat(item.pipeline_amount ?? 0) || 0;
      const tinShedCompensationAmount = parseFloat(item.tinshed_amount ?? 0) || 0;
      const wireCompensationAmount = parseFloat(item.wire_amount ?? 0) || 0;
      const otherAssetCompensationAmount = parseFloat(item.other_asset_amount ?? 0) || 0;
      const farmPondCompensationAmount = parseFloat(item.farmpond_amount ?? 0) || 0;

      const solatiumAmount = parseFloat(item.solatium_compensation_amount ?? 0) || 0;
      const interestAmount = parseFloat(item.interest_amount ?? 0) || 0;
      const additionalCompensation = parseFloat(item.additional_compensation ?? 0) || 0;
      const totalCompensation = parseFloat(item.total_compensation ?? 0) || 0;

      const acquiredAreaValue = parseFloat(item.owner_aqr_area ?? 0) || 0;
      const landValueTotal = parseFloat(item.land_amount ?? 0) || 0;

      let propertyDescriptions = [];

      // Helper function to add descriptions for each property instance
      const addPropertyDescriptions = (items, type) => {
        if (items && Array.isArray(items) && items.length > 0) {
          items.forEach((item, index) => {
            // Add numbered description for each instance (e.g., "Well 1", "Well 2")
            propertyDescriptions.push(`${type}`);
          });
        }
      };

      // Process each property type
      addPropertyDescriptions(item.borewell, translations[language].Borewelldepth || 'Borewell');
      addPropertyDescriptions(item.pipeline, translations[language].Pipelinelength || 'Pipeline');
      addPropertyDescriptions(item.home, translations[language].Homearea || 'Home');
      addPropertyDescriptions(item['tinshed/godown'], translations[language].TinShedarea || 'Tinshed');
      addPropertyDescriptions(item.wirefencing, translations[language].Wirefencingarea || 'Wirefencing');
      addPropertyDescriptions(item.well, translations[language].Wellvolume || 'Well');
      addPropertyDescriptions(item.farmpond, translations[language].Farmpondvolume || 'Farm Pond');
      if (item.other && Array.isArray(item.other) && item.other.length > 0) {
        item.other.forEach(obj => {
          const label = obj.construction_type || "Other";
          propertyDescriptions.push(`${label}`);
        });
      }
      const calculateProduct = (obj) => {
        let product = 1;
        let hasValue = false;
        ['Property_length', 'Property_width', 'Property_depth', 'Property_height'].forEach(field => {
          const val = parseFloat(obj[field]);
          if (!isNaN(val) && obj[field] !== null) {
            product *= val;
            hasValue = true;
          }
        });
        return hasValue ? product : 0; // Return 0 for summing, will handle '-' in addPropertyArea
      };

      // Array for property areas, similar to propertyDescriptions
      const propertyAreas = [];

      const addPropertyArea = (items, array, label) => {
        if (items && Array.isArray(items)) {
          items.forEach(item => {
            const area = calculateProduct(item);
            if (area !== 0) {
              array.push(`${area.toFixed(2)} (${label})`);
            } else {
              array.push(`- (${label})`);
            }
          });
        }
      };

      // Calculate and push for each property type
      addPropertyArea(item.borewell, propertyAreas, translations[language].Agmeter);
      addPropertyArea(item.pipeline, propertyAreas, translations[language].Agmeter);
      addPropertyArea(item.home, propertyAreas, translations[language].Agsquaremeter);
      addPropertyArea(item['tinshed/godown'], propertyAreas, translations[language].Agsquaremeter);
      addPropertyArea(item.wirefencing, propertyAreas, translations[language].Agsquaremeter);
      addPropertyArea(item.well, propertyAreas, translations[language].Cubicmeter);
      addPropertyArea(item.farmpond, propertyAreas, translations[language].Cubicmeter);
      if (item.other && Array.isArray(item.other) && item.other.length > 0) {
        item.other.forEach(obj => {
          const count = obj.Property_count ?? "-";
          propertyAreas.push(`${count}`);
        });
      }

      const propertyYears = [];
      const propertyActualAreas = [];
      const propertyRemarks = [];
      const propertyPaymentDue = [];
      let treeRemarks = [];

      // Filter tree remarks by agency
      if (item.tree && Array.isArray(item.tree)) {
        if (selectedAgency === "agriculture") {
          treeRemarks = item.tree
            .filter(t => t.tree_type_name1 === "फळझाडे")
            .map(t => (t.remarks && t.remarks.trim() !== "" ? t.remarks : "-"));
        } else if (selectedAgency === "forest") {
          treeRemarks = item.tree
            .filter(t => t.tree_type_name1 === "वनझाडे")
            .map(t => (t.remarks && t.remarks.trim() !== "" ? t.remarks : "-"));
        } else {
          // default: all trees
          treeRemarks = item.tree.map(
            t => (t.remarks && t.remarks.trim() !== "" ? t.remarks : "-")
          );
        }
      }

      // Helper function to add individual year to propertyYears
      const addPropertyYear = (items, array) => {
        if (items && Array.isArray(items)) {
          items.forEach(item => {
            const year = item.year_of_construction || '-';
            array.push(year);
          });
        }
      };

      // Helper function to add individual actual area to propertyActualAreas
      const addPropertyActual = (items, array) => {
        if (items && Array.isArray(items)) {
          items.forEach(item => {
            const area = parseFloat(item.actual_area);
            array.push(!isNaN(area) && item.actual_area !== null ? area.toFixed(2) : '-');
          });
        }
      };

      // Helper function to add individual remark to propertyRemarks
      const addPropertyRemark = (items, array) => {
        if (items && Array.isArray(items)) {
          items.forEach(item => {
            const remark = item.remarks && item.remarks.trim() !== "" ? item.remarks : "-";
            array.push(remark);
          });
        }
      };

      // Helper function to add individual remark to PropertyPaymentDue
      const addPropertyPaymentDue = (items, array) => {
        if (items && Array.isArray(items)) {
          items.forEach(item => {
            const payment = item.Property_amount_valuer && item.Property_amount_valuer.toString().trim() !== ""
              ? item.Property_amount_valuer
              : "-";
            array.push(payment);
          });
        }
      };

      // Calculate and push for each property type
      addPropertyYear(item.borewell, propertyYears);
      addPropertyYear(item.pipeline, propertyYears);
      addPropertyYear(item.home, propertyYears);
      addPropertyYear(item['tinshed/godown'], propertyYears);
      addPropertyYear(item.wirefencing, propertyYears);
      addPropertyYear(item.well, propertyYears);
      addPropertyYear(item.farmpond, propertyYears);
      addPropertyYear(item.other, propertyYears);

      addPropertyActual(item.borewell, propertyActualAreas);
      addPropertyActual(item.pipeline, propertyActualAreas);
      addPropertyActual(item.home, propertyActualAreas);
      addPropertyActual(item['tinshed/godown'], propertyActualAreas);
      addPropertyActual(item.wirefencing, propertyActualAreas);
      addPropertyActual(item.well, propertyActualAreas);
      addPropertyActual(item.farmpond, propertyActualAreas);
      addPropertyActual(item.other, propertyActualAreas);

      // Collect remarks for each property type
      addPropertyRemark(item.borewell, propertyRemarks);
      addPropertyRemark(item.pipeline, propertyRemarks);
      addPropertyRemark(item.home, propertyRemarks);
      addPropertyRemark(item['tinshed/godown'], propertyRemarks);
      addPropertyRemark(item.wirefencing, propertyRemarks);
      addPropertyRemark(item.well, propertyRemarks);
      addPropertyRemark(item.farmpond, propertyRemarks);
      addPropertyRemark(item.other, propertyRemarks);

      // Collect PropertyPaymentDue for each property type
      addPropertyPaymentDue(item.borewell, propertyPaymentDue);
      addPropertyPaymentDue(item.pipeline, propertyPaymentDue);
      addPropertyPaymentDue(item.home, propertyPaymentDue);
      addPropertyPaymentDue(item['tinshed/godown'], propertyPaymentDue);
      addPropertyPaymentDue(item.wirefencing, propertyPaymentDue);
      addPropertyPaymentDue(item.well, propertyPaymentDue);
      addPropertyPaymentDue(item.farmpond, propertyPaymentDue);
      addPropertyPaymentDue(item.other, propertyPaymentDue);


      let landRate = 0;
      if (item.land_rate) {
        landRate = parseFloat(item.land_rate);
      } else if (landValueTotal && acquiredAreaValue > 0) {
        landRate = landValueTotal / acquiredAreaValue;
      }

      return {
        id: item.compensation_id || ownerId,
        compId: item.compensation_id || ownerId,
        landOwnerId: item.land_owner_id,
        owner_name: item.owner_name || 'No Owner Available',
        surveyNo: item.survey_no || 'N/A',
        rawData: item,
        acquiredArea: acquiredAreaValue,
        landRate: landRate,
        owner_aqr_area_land_rate: item.owner_aqr_area_land_rate != null ? parseFloat(item.owner_aqr_area_land_rate) : 0,

        wellCount,
        structureCount,
        treeCount,
        cropCount,
        waterBodyCount,
        borewellCount,
        homeCount,
        pipelineCount,
        tinShedCount,
        wireCount,
        otherAssetCount,
        farmPondCount,
        propertyDescriptions,
        propertyAreas,
        propertyYears,
        propertyActualAreas,
        propertyRemarks,
        propertyPaymentDue,
        treeRemarks,

        landCompensation: landValueTotal,
        structureCompensation: structureCompensationAmount,
        treeCompensation: treeCompensationAmount,
        cropCompensation: cropCompensationAmount,
        waterBodyCompensation: waterBodyCompensationAmount,
        borewellCompensation: borewellCompensationAmount,
        homeCompensation: homeCompensationAmount,
        pipelineCompensation: pipelineCompensationAmount,
        tinShedCompensation: tinShedCompensationAmount,
        wireCompensation: wireCompensationAmount,
        otherAssetCompensation: otherAssetCompensationAmount,
        wellCompensation: wellCompensationAmount,
        farmPondCompensation: farmPondCompensationAmount,

        solatium30: solatiumAmount,
        interestAward: interestAmount,
        additionalCompensation: additionalCompensation,
        totalFinalAward: totalCompensation,
        remarks: item.remarks || '',
        compensationStatus: item.COMPENSATION_STATUS || 'Pending',
        projectId: item.project_id,
        landAcquisitionId: item.LandAcquisition_id,
        paymentDue: item.Property_amount_valuer || "",

        treeRate: parseFloat(item.no_of_tree_rate ?? 0) || 0,
        cropRate: parseFloat(item.no_of_crop_rate ?? 0) || 0,
        structureRate: parseFloat(item.no_of_structure_rate ?? 0) || 0,
        waterBodyRate: parseFloat(item.no_of_water_body_rate ?? 0) || 0,
        borewellRate: parseFloat(item.no_of_borewell_rate ?? 0) || 0,
        homeRate: parseFloat(item.no_of_home_rate ?? 0) || 0,
        pipelineRate: parseFloat(item.no_of_pipeline_rate ?? 0) || 0,
        tinShedRate: parseFloat(item.no_of_tinshed_rate ?? 0) || 0,
        wireRate: parseFloat(item.no_of_wire_rate ?? 0) || 0,
        otherAssetRate: parseFloat(item.no_of_other_asset_rate ?? 0) || 0,
        wellRate: parseFloat(item.no_of_well_rate ?? 0) || 0,

        no_of_tree_rate: parseFloat(item.no_of_tree_rate ?? 0) || 0,
        no_of_crop_rate: parseFloat(item.no_of_crop_rate ?? 0) || 0,
        no_of_structure_rate: parseFloat(item.no_of_structure_rate ?? 0) || 0,
        no_of_water_body_rate: parseFloat(item.no_of_water_body_rate ?? 0) || 0,
        no_of_borewell_rate: parseFloat(item.no_of_borewell_rate ?? 0) || 0,
        no_of_home_rate: parseFloat(item.no_of_home_rate ?? 0) || 0,
        no_of_pipeline_rate: parseFloat(item.no_of_pipeline_rate ?? 0) || 0,
        no_of_tinshed_rate: parseFloat(item.no_of_tinshed_rate ?? 0) || 0,
        no_of_wire_rate: parseFloat(item.no_of_wire_rate ?? 0) || 0,
        no_of_other_asset_rate: parseFloat(item.no_of_other_asset_rate ?? 0) || 0,
        no_of_well_rate: parseFloat(item.no_of_well_rate ?? 0) || 0,


        district: item.dist_name || selectedDistrict,
        taluka: item.taluka_name || selectedTaluka,
        village: item.village_name || selectedVillage
      };
    });
  };

  // Helper functions for display names
  const getDistrictDisplayName = (district) => {
    return district.dist_name || district.district_name || `District ${district.dist_name}`;
  };

  const getTalukaDisplayName = (taluka) => {
    return taluka.taluka_name || taluka.tehsil_name || `Taluka ${taluka.taluka_name}`;
  };

  const getVillageDisplayName = (village) => {
    return village.village_name || village.vill_name || `Village ${village.village_name}`;
  };

  // Helper function to get current location description
  const getCurrentLocationDescription = () => {
    if (filterMode === 'all') {
      return 'All Locations';
    }

    if (selectedDistrict && selectedTaluka && selectedVillage) {
      return `${selectedVillage}, ${selectedTaluka}, ${selectedDistrict}`;
    } else if (selectedDistrict && selectedTaluka) {
      return `Taluka: ${selectedTaluka}, ${selectedDistrict}`;
    } else if (selectedDistrict) {
      return `District: ${selectedDistrict}`;
    } else {
      return 'No location selected';
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // SIMPLE CALCULATION FUNCTIONS
  const calculateAmount = (count, rate) => {
    const countVal = parseFloat(count) || 0;
    const rateVal = parseFloat(rate) || 0;
    return countVal * rateVal;
  };

  // SIMPLE INPUT CHANGE HANDLER - NO COMPLEX LOGIC
  const handleEditInputChange = (field, value) => {
    setEditingValues(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Handle inline edit start - CLEAN VERSION
  const handleEditStart = (record) => {
    const measureId = record.landOwnerId;

    if (!measureId) {
      setError('Unable to edit this record: No LandAcquisition_id found.');
      return;
    }

    setEditingRowId(record.id); // Now using the proper id field
    setEditingValues({
      owner_aqr_area_land_rate: record.owner_aqr_area_land_rate ?? '',
      no_of_structure_rate: record.structureRate ?? '',
      no_of_tree_rate: record.treeRate ?? '',
      no_of_crop_rate: record.cropRate ?? '',
      no_of_water_body_rate: record.waterBodyRate ?? '',
      no_of_borewell_rate: record.borewellRate ?? '',
      no_of_home_rate: record.homeRate ?? '',
      no_of_tinshed_rate: record.tinShedRate ?? '',
      no_of_pipeline_rate: record.pipelineRate ?? '',
      no_of_wire_rate: record.wireRate ?? '',
      no_of_other_asset_rate: record.otherAssetRate ?? '',
      measureId
    });
    setEditError(null);
  };

  // Handle inline edit cancel - CLEAN VERSION
  const handleEditCancel = () => {
    setEditingRowId(null);
    setEditingValues({});
    setEditError(null);
  };

  // Handle inline edit save - CLEAN VERSION
  const handleEditSave = async (record) => {
    try {
      setEditingCompensation(true);
      setEditError(null);
      setError(null); // Clear any existing errors

      const measureId = editingValues.measureId;

      const measurementPayload = {
        owner_aqr_area_land_rate: parseFloat(editingValues.owner_aqr_area_land_rate) || 0,
        no_of_structure_rate: parseFloat(editingValues.no_of_structure_rate) || 0,
        no_of_tree_rate: parseFloat(editingValues.no_of_tree_rate) || 0,
        no_of_crop_rate: parseFloat(editingValues.no_of_crop_rate) || 0,
        no_of_water_body_rate: parseFloat(editingValues.no_of_water_body_rate) || 0,
        no_of_borewell_rate: parseFloat(editingValues.no_of_borewell_rate) || 0,
        no_of_home_rate: parseFloat(editingValues.no_of_home_rate) || 0,
        no_of_tinshed_rate: parseFloat(editingValues.no_of_tinshed_rate) || 0,
        no_of_pipeline_rate: parseFloat(editingValues.no_of_pipeline_rate) || 0,
        no_of_wire_rate: parseFloat(editingValues.no_of_wire_rate) || 0,
        no_of_well_rate: parseFloat(editingValues.no_of_well_rate) || 0,
        no_of_other_asset_rate: parseFloat(editingValues.no_of_other_asset_rate) || 0,
        no_of_fram_pound: parseFloat(editingValues.no_of_fram_pound) || 0,
        no_of_fram_pound_rate: parseFloat(editingValues.no_of_fram_pound_rate) || 0
      };

      const cleanPayload = Object.fromEntries(
        Object.entries(measurementPayload).filter(([_, value]) => value !== null && value !== 0)
      );

      const response = await apiService.patchHighwayUpdateMeasurement(measureId, cleanPayload);

      if (response && (response.status === 200 || response.status === 204)) {
        // Set success message
        setSuccess(true);
        setSuccessMessage(`Compensation rates updated successfully for ${record.owner_name}!`);

        // Clear editing states
        setEditingRowId(null);
        setEditingValues({});

        // Reload data
        await loadCompensationData();

        // Auto-hide success message after 4 seconds
        setTimeout(() => {
          setSuccess(false);
          setSuccessMessage('');
        }, 4000);

      } else {
        throw new Error(`Invalid response from server: ${response?.status || 'Unknown'}`);
      }
    } catch (error) {
      console.error('Error updating measurement rates:', error);
      setEditError('Failed to update measurement rates: ' + error.message);
    } finally {
      setEditingCompensation(false);
    }
  };

  const fetchUserslao = async () => {
    setLoadingUsers(true);
    try {
      const role = 3;
      const response = await apiService.getAssignLAO(role, currentProjectId, currentProposalId); // this must return LAO users
      if (response.status === 200 && response.data) {
        setUsers(Array.isArray(response.data) ? response.data : []);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const fetchUsersSamanvay = async () => {
    setLoadingUsers(true);
    try {
      const response = await apiService.getAllUserRoleSamanvay(); // must return Samanvay users
      if (response.status === 200 && response.data) {
        setUsersSamanvay(Array.isArray(response.data) ? response.data : []);
      }
    } catch (error) {
      console.error('Error fetching Samanvay users:', error);
      setUsersSamanvay([]);
    } finally {
      setLoadingUsers(false);
    }
  };


  // Filter data based on search
  const filteredData = compensationData.filter(record => {
    const matchesSearch =
      record.owner_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      record.landOwnerId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      record.surveyNo.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (record.district && record.district.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (record.taluka && record.taluka.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (record.village && record.village.toLowerCase().includes(searchTerm.toLowerCase()));

    return matchesSearch;
  });

  // Calculate summary statistics
  const summaryStats = {
    totalRecords: filteredData.length,
    totalCompensation: filteredData.reduce((sum, record) => sum + (record.totalFinalAward || 0), 0),
    avgCompensation: filteredData.length > 0 ? filteredData.reduce((sum, record) => sum + (record.totalFinalAward || 0), 0) / filteredData.length : 0,
    totalArea: filteredData.reduce((sum, record) => sum + (record.acquiredArea || 0), 0)
  };

  // Get visible columns for current agency
  const visibleColumns = getVisibleColumns();
  const agencyInfo = getAgencyInfo();

  if (loading && compensationData.length === 0) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <Loader className="h-12 w-12 animate-spin text-blue-500" />
          <p className="text-gray-600 text-lg font-medium">{translations[language].LoadingData}</p>
          <p className="text-gray-500 text-sm">{translations[language].PleaseWait}</p>
        </div>
      </div>
    );
  }

  // Handle viewing documents in modal
  const handleViewDocument = (urlOrFile) => {
    if (!urlOrFile) return;

    let url;
    let isPdf;

    if (urlOrFile instanceof File) {
      url = URL.createObjectURL(urlOrFile);
      isPdf = urlOrFile.type === 'application/pdf';
    } else { // Assuming it's a URL string from backend
      url = urlOrFile;
      isPdf = urlOrFile.toLowerCase().includes('.pdf');
    }

    setFileUrlToView(url);
    setIsPDFToView(isPdf);
    setShowDocumentViewer(true);
  };

  const closeDocumentViewer = () => {
    setShowDocumentViewer(false);
    // Revoke Object URL if it was created from a File object
    if (fileUrlToView.startsWith('blob:')) {
      URL.revokeObjectURL(fileUrlToView);
    }
    setFileUrlToView('');
    setIsPDFToView(false);
  };

  const handlePrint = () => {
    const printContent = printRef.current?.innerHTML;
    if (!printContent) {
      alert("No content available to print.");
      return;
    }

    const agencyName = agencyInfo.label?.props?.children || 'Agency Report';

    const win = window.open("", "", "height=900,width=1200");
    win.document.write(`
    <html>
      <head>
        <title>Concern Valuer Report</title>
        <style>
          @page {
            size: A4 portrait;
            margin-top: 0.19in;
            margin-bottom: 0.25in;
            margin-left: 0.81in;
            margin-right: 0.5in;
          }
          body {
            font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
            font-size: 12px;
          }
          .print-header {
            text-align: center;
          }
          .print-header h2 {
            font-size: 16px;
            font-weight: bold;
          }
          .print-footer {
            margin-top: 40px;
            text-align: right;
            font-weight: bold;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
          }
          th, td {
            border: 1px solid #333;
            padding: 6px;
            text-align: center;
            font-size: 11px;
          }
          th {
            background-color: #f0f0f0;
            font-weight: bold;
          }
          .text-center { text-align: center; }
          .font-bold { font-weight: bold; }
          /* Hide action column in print */
          .no-print {
            display: none !important;
          }
        </style>
      </head>
      <body>
        <div class="print-header">
          <h2>भूसंपादन प्रकरण क्र. ${proposalNo || 'N/A'}</h2>
          <h2>${agencyName} संस्था</h2>
        </div>
        ${printContent}
        <div class="print-footer">
          <p>सही/-</p>
          <p>${agencyName} संबंधित अधिकारी</p>
        </div>
      </body>
    </html>
  `);

    win.document.close();
    win.print();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
      {/* Success/Error Messages */}
      {success && (
        <div className="mx-6 mt-6 p-4 rounded-xl bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200">
          <div className="flex items-center text-green-800">
            <CheckCircle className="w-5 h-5 mr-3" />
            <span className="font-medium">
              {successMessage || "Operation completed successfully!"}
            </span>
          </div>
        </div>
      )}

      {(error || editError) && (
        <div className="mx-6 mt-6 p-4 rounded-xl bg-gradient-to-r from-red-50 to-rose-50 border border-red-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center text-red-800">
              <AlertCircle className="w-5 h-5 mr-3" />
              <span className="font-medium">{error || editError}</span>
            </div>
            <button
              onClick={() => {
                setError(null);
                setEditError(null);
              }}
              className="text-red-600 hover:text-red-800"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      <div className="px-6 pb-6">
        {/* NEW: Enhanced Filter Panel - Similar to Proposal Component */}
        <div className="mt-6 backdrop-blur-xl bg-white/70 rounded-2xl shadow-lg border border-white/50 overflow-hidden">
          <div className="bg-gradient-to-r from-blue-500/10 to-indigo-500/10 px-6 py-4 border-b border-gray-200/50">
            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
              <div className="flex items-center space-x-3">
                <div>
                  {selectedAgency && (
                    <div className="flex items-center space-x-2 mb-4 bg-white shadow-md px-4 py-2 rounded-xl w-fit mx-6 mt-4">
                      {agencyInfo.icon}
                      <span className={`font-semibold ${agencyInfo.color}`}>
                        {agencyInfo.label} {translations[language].AgencySelected}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Filter Toggle Button */}
              <div className="flex flex-wrap gap-3">
                <button
                  onClick={() => setShowFilterPanel(!showFilterPanel)}
                  className="px-4 py-2 bg-gradient-to-r from-orange-700 to-orange-500 hover:from-orange-700 hover:to-orange-900 text-white rounded-lg flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-gray-200 hover:shadow-gray-300 group"
                >
                  <Filter className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                  <span className="font-medium">{translations[language].Filters}</span>
                  {showFilterPanel ? (
                    <ChevronUp className="h-4 w-4 transition-transform duration-300" />
                  ) : (
                    <ChevronDown className="h-4 w-4 transition-transform duration-300" />
                  )}
                </button>

                {userRole !== USER_ROLES.DATA_ENTRY && (
                  <button
                    onClick={() => {
                      fetchUserslao();
                      fetchUsersSamanvay();
                      setShowSendToLAOModal(true);
                      setIsCompensationButtonClicked(true); // just visual change, not disabling
                    }}
                    className={`px-4 py-2 font-semibold rounded-xl shadow-lg flex items-center transition-all duration-200 ${isCompensationButtonClicked
                      ? "bg-red-600 text-white"
                      : "bg-blue-600 text-white hover:bg-blue-700"
                      }`}
                  >
                    <Send className="mr-2 h-5 w-5" />
                    {isCompensationButtonClicked
                      ? <span>{translations[language].CommonSave}</span>
                      : <span>{translations[language].CommonSave}</span>}
                  </button>
                )}

                <button
                  onClick={handlePrint}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg flex items-center space-x-2 transition-all duration-300 shadow-lg hover:bg-green-700 group"
                >
                  <span className="font-medium">{translations[language]?.Print || 'Print'}</span>
                </button>

              </div>
            </div>
          </div>

          {/* Collapsible Filter Panel */}
          {showFilterPanel && (
            <div className="border-t border-gray-200 bg-gray-50/50 backdrop-blur-sm">
              <div className="p-6 space-y-6">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                  {/* Filter Mode Selection */}
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-1 bg-gray-100 rounded-lg p-1">
                      <button
                        onClick={() => setFilterMode("all")}
                        className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === "all"
                          ? "bg-white text-blue-600 shadow-sm"
                          : "text-gray-600 hover:text-gray-800"
                          }`}
                      >
                        <Globe className="h-4 w-4" />
                        <span>{translations[language].AllRecords}</span>
                      </button>
                      <button
                        onClick={() => setFilterMode("location")}
                        className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === "location"
                          ? "bg-white text-blue-600 shadow-sm"
                          : "text-gray-600 hover:text-gray-800"
                          }`}
                      >
                        <MapPin className="h-4 w-4" />
                        <span>{translations[language].FilterByLocation}</span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Location Filters - Only show when location mode is selected */}
                {filterMode === "location" && (
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <MapPin className="h-5 w-5 text-blue-600 mr-2" />
                      <h3 className="text-lg font-semibold text-gray-800">
                        {translations[language].selectLocation}
                      </h3>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {translations[language].district} <span className="text-red-500">*</span>
                        </label>
                        <select
                          value={selectedDistrict}
                          onChange={handleDistrictChange}
                          disabled={loadingDistricts}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                        >
                          <option value="">
                            {loadingDistricts
                              ? <span>{translations[language].loadingDistricts}</span>
                              : <span>{translations[language].selectDistrict}</span>}
                          </option>
                          {districts.map((district, index) => (
                            <option
                              key={district.dist_name || index}
                              value={district.dist_name}
                            >
                              {getDistrictDisplayName(district)}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {translations[language].taluka}
                        </label>
                        <select
                          value={selectedTaluka}
                          onChange={handleTalukaChange}
                          disabled={!selectedDistrict || loadingTalukas}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                        >
                          <option value="">
                            {loadingTalukas
                              ? <span>{translations[language].loadingTalukas}</span>
                              : <span>{translations[language].selectTaluka}</span>}
                          </option>
                          {availableTalukas.map((taluka, index) => (
                            <option
                              key={taluka.taluka_name || index}
                              value={getTalukaDisplayName(taluka)}
                            >
                              {getTalukaDisplayName(taluka)}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {translations[language].village}
                        </label>
                        <select
                          value={selectedVillage}
                          onChange={handleVillageChange}
                          disabled={!selectedTaluka || loadingVillages}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                        >
                          <option value="">
                            {loadingVillages
                              ? <span>{translations[language].loadingVillages}</span>
                              : <span>{translations[language].selectVillage}</span>}
                          </option>
                          {availableVillages.map((village, index) => (
                            <option
                              key={village.village_name || index}
                              value={getVillageDisplayName(village)}
                            >
                              {getVillageDisplayName(village)}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {/* UPDATED: Show helpful message about progressive filtering */}
                    {filterMode === "location" && !selectedDistrict && (
                      <p className="text-sm text-amber-600">
                        {translations[language].PleaseSelectDistrict}
                      </p>
                    )}
                    {filterMode === "location" && selectedDistrict && (
                      <p className="text-sm text-green-600">
                        ✓{translations[language].ShowingDataFor}: {getCurrentLocationDescription()}
                      </p>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {showSendToLAOModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="space-y-4">
                  {/* User Selection */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {translations[language].SelectLAOUser} *
                    </label>
                    <select
                      value={selectedUser}
                      onChange={(e) => setSelectedUser(e.target.value)}
                      disabled={loadingUsers}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">
                        {loadingUsers
                          ? <span>{translations[language].LoadingOfficers}</span>
                          : <span>{translations[language].SelectOfficer}</span>}
                      </option>
                      {users.map((user) => (
                        <option
                          key={user.id || user.usr_id}
                          value={user.id || user.usr_id}
                        >
                          {user.full_name || user.user_name} ({user.usr_role})
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Remarks */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {translations[language].Remarks}
                    </label>
                    <textarea
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                      rows={3}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      placeholder={translations[language].EnterRemarks}
                    />
                  </div>

                  {/* Document Upload */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {translations[language].UploadDocument} *
                    </label>
                    <input
                      type="file"
                      onChange={(e) => setSelectedDocument(e.target.files[0])}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    />
                    {selectedDocument && (
                      <p className="text-xs text-green-600 mt-1">
                      </p>
                    )}
                  </div>
                </div>

                {/* Modal Actions */}
                <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                  <button
                    onClick={() => setShowSendToLAOModal(false)}
                    className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                    disabled={sendingToLAO}
                  >
                    {translations[language].Cancel}
                  </button>
                  <button
                    onClick={handleSendToLao}
                    disabled={
                      sendingToLAO || !selectedUser || !selectedDocument
                    }
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                  >
                    {sendingToLAO ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                        {translations[language].Sending}
                      </>
                    ) : (
                      <>
                        <Send className="mr-2 h-4 w-4" />
                        {translations[language].CommonSave}
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Compensation Records Table */}
        {canShowData && (
          <div className="mt-6 backdrop-blur-xl bg-white/90 rounded-2xl shadow-lg border border-white/50 overflow-hidden">
            <div className="overflow-x-auto" ref={printRef}>
              <table className="w-full border-collapse min-w-[1200px]">
                <thead>
                  <pre className="text-red-600 text-xs">
                    {" "}
                  </pre>

                  <tr className="bg-gradient-to-r from-gray-100 to-gray-200">
                    <th className="border border-gray-400 px-2 py-2 text-xs font-bold text-gray-800 text-center w-20 no-print">
                      {translations[language].AgAction}
                    </th>

                    <th className="border border-gray-400 px-2 py-2 text-xs font-bold text-gray-800 text-center w-12">
                      {translations[language].SrNo}
                    </th>
                    <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">
                      {translations[language].landholderName}
                    </th>
                    <th className="border border-gray-400 px-2 py-2 text-xs font-bold text-gray-800 text-center w-20">
                      {translations[language].AgSurveyGatNo}
                    </th>

                    {visibleColumns.tree && (
                      <th className="border border-gray-400 px-2 py-2 text-xs font-bold text-gray-800 text-center w-28">
                        {selectedAgency === "agriculture"
                          ? <span>{translations[language].Typesoffruittrees}</span>
                          : selectedAgency === "forest"
                            ? <span>{translations[language].Foresttype}</span>
                            : translations[language].tree}
                        <br />
                      </th>
                    )}

                    {visibleColumns.count && (
                      <th className="border border-gray-400 px-2 py-2 text-xs font-bold text-gray-800 text-center w-28">
                        {translations[language].Numericalcount}
                      </th>
                    )}

                    {/* Agriculture and Forest Agency */}
                    {/* {(selectedAgency === 'agriculture' || selectedAgency === 'forest') && ( */}
                    {/* Data Entry */}
                    {(selectedAgency === 'agriculture' || selectedAgency === 'forest' || selectedAgency === "data_entry") && (
                      <>
                        <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">
                          {selectedAgency === 'agriculture'
                            ? translations[language]?.Numberofactuals || 'Fruit Trees'
                            : translations[language]?.Numberofactuals || 'Forest Trees'}
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">
                          {translations[language]?.Compensationpayable || 'Tree Compensation'}
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">
                          {translations[language].Remarks || "Remarks"}
                        </th>

                      </>
                    )}

                    {/* Other Agency */}
                    {/* {(selectedAgency === 'consulting_agent') && ( */}
                    {/* Data Entry */}
                    {(selectedAgency === 'consulting_agent' || selectedAgency === 'data_entry') && (
                      <>
                        <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">
                          {translations[language]?.PropertyDescription}
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">
                          {translations[language]?.Areacalculation}
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">
                          {translations[language]?.Yearofconstruction}
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">
                          {translations[language]?.Aga}
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">
                          {translations[language].Paymentdue || "Payment Due"}
                        </th>
                        <th className="border border-gray-400 px-3 py-2 text-xs font-bold text-gray-800 text-center w-32">
                          {translations[language].Remarks || "Remarks"}
                        </th>


                      </>
                    )}


                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="20" className="border border-gray-400 px-6 py-12 text-center">
                        <div className="flex flex-col items-center justify-center space-y-3">
                          <Loader className="w-8 h-8 animate-spin text-blue-500" />
                          <div className="text-gray-500 font-medium">
                            {translations[language].LoadingCompensationRecords}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : filteredData.length === 0 ? (
                    <tr>
                      <td colSpan="20" className="border border-gray-400 px-6 py-12 text-center">
                        <div className="flex flex-col items-center justify-center space-y-3">
                          <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center">
                            <FileText className="w-8 h-8 text-gray-400" />
                          </div>
                          <div className="text-gray-500 font-medium">
                            {filterMode === "location" && !hasValidLocationSelection
                              ? "Please select at least a District to load compensation data"
                              : searchTerm
                                ? `No compensation records found matching "${searchTerm}"`
                                : "No compensation records found"}
                          </div>
                          {filterMode === "location" && hasValidLocationSelection && currentProjectId && (
                            <div className="text-xs text-gray-400">
                              {translations[language].ProjectID}: {currentProjectId}
                              {currentProposalId && ` | Proposal ID: ${currentProposalId}`}
                              <br />
                              {translations[language].Location}: {getCurrentLocationDescription()}
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {filteredData.map((record, ownerIndex) => {
                        const numAssets =
                          (selectedAgency === 'agriculture' || selectedAgency === 'forest'
                            ? (record.rawData.tree || []).filter(t =>
                              (selectedAgency === 'agriculture' && t.tree_type_name1 === 'फळझाडे') ||
                              (selectedAgency === 'forest' && t.tree_type_name1 === 'वनझाडे')
                            ).length
                            : record.propertyDescriptions?.length) || 1;

                        return Array.from({ length: numAssets }, (_, assetIndex) => {
                          const isEditing = editingRowId === record.id;
                          const tree = (record.rawData.tree || [])[assetIndex];
                          const treeFiltered = (record.rawData.tree || []).filter(t =>
                            (selectedAgency === 'agriculture' && t.tree_type_name1 === 'फळझाडे') ||
                            (selectedAgency === 'forest' && t.tree_type_name1 === 'वनझाडे')
                          )[assetIndex];

                          return (
                            <tr
                              key={`${record.id}-${assetIndex}`}
                              className={`transition-colors duration-150 ${isEditing ? "bg-blue-50" : "hover:bg-gray-50"} ${ownerIndex % 2 === 0 ? "bg-white" : "bg-gray-50"
                                }`}
                            >
                              {/* Actions */}
                              {assetIndex === 0 && (
                                <td rowSpan={numAssets} className="border border-gray-400 px-2 py-2 text-center no-print">
                                  <div className="flex items-center justify-center space-x-1">
                                    {isEditing ? (
                                      <>
                                        <button
                                          onClick={() => handleEditSave(record)}
                                          disabled={editingCompensation}
                                          className="p-1.5 rounded-lg bg-green-500 hover:bg-green-600 disabled:bg-green-300 text-white transition-all duration-200 hover:shadow-lg"
                                          title="Save All Changes"
                                        >
                                          {editingCompensation ? (
                                            <Loader className="w-3 h-3 animate-spin" />
                                          ) : (
                                            <Save className="w-3 h-3" />
                                          )}
                                        </button>
                                        <button
                                          onClick={handleEditCancel}
                                          disabled={editingCompensation}
                                          className="p-1.5 rounded-lg bg-red-500 hover:bg-red-600 disabled:bg-red-300 text-white transition-all duration-200 hover:shadow-lg"
                                          title="Cancel"
                                        >
                                          <X className="w-3 h-3" />
                                        </button>
                                      </>
                                    ) : (
                                      <button
                                        onClick={() => {
                                          setEditRecord(record.rawData); // full backend row
                                          setShowEditModal(true);
                                        }}
                                        className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
                                      >
                                        <Edit2 size={16} />
                                      </button>
                                    )}
                                  </div>
                                </td>
                              )}
                              {/* Serial Number */}
                              {assetIndex === 0 && (
                                <td rowSpan={numAssets} className="border border-gray-400 px-2 py-2 text-center text-sm font-bold text-gray-900">
                                  {ownerIndex + 1}
                                </td>
                              )}

                              {/* Owner Details */}
                              {assetIndex === 0 && (
                                <td rowSpan={numAssets} className="border border-gray-400 px-3 py-2 text-sm">
                                  <div className="space-y-1">
                                    <div className="font-bold text-gray-900 text-sm leading-tight">
                                      {record.owner_name}
                                    </div>
                                  </div>
                                </td>
                              )}

                              {/* Survey No */}
                              {assetIndex === 0 && (
                                <td rowSpan={numAssets} className="border border-gray-400 px-2 py-2 text-center">
                                  <div className="text-sm font-bold text-blue-600">
                                    {record.surveyNo}
                                  </div>
                                </td>
                              )}

                              {/* Tree */}
                              {visibleColumns.tree && (
                                <td className="border border-gray-400 py-2">
                                  <div className="space-y-0 text-center">
                                    {treeFiltered ? (
                                      <div className="py-1 text-gray-800">
                                        <span className="font-medium text-gray-700">{treeFiltered.tree_type_name}</span>
                                      </div>
                                    ) : (
                                      <div className="py-1 text-center text-gray-500">-</div>
                                    )}
                                  </div>
                                </td>
                              )}

                              {/* Numerical Count */}
                              {visibleColumns.count && (
                                <td className="border border-gray-400 py-2">
                                  <div className="space-y-0 text-center">
                                    {treeFiltered ? (
                                      <div className="py-1 text-gray-800">
                                        <span className="font-bold text-gray-900">{treeFiltered.tree_count}</span>
                                      </div>
                                    ) : (
                                      <div className="py-1 text-center text-gray-500">-</div>
                                    )}
                                  </div>
                                </td>
                              )}

                              {/* Agriculture or Forest Agency Columns */}
                              {/* {(selectedAgency === 'agriculture' || selectedAgency === 'forest') && ( */}
                              {/* Data Entry */}
                              {(selectedAgency === 'agriculture' || selectedAgency === 'forest' || selectedAgency === 'data_entry') && (
                                <>
                                  <td className="border border-gray-400 py-2">
                                    <div className="space-y-0 text-center">
                                      {treeFiltered ? (
                                        <div className="py-1 text-gray-800">
                                          {(parseFloat(treeFiltered.tree_value_valuer) || 0).toLocaleString()}
                                        </div>
                                      ) : (
                                        <div className="py-1 text-center text-gray-500">-</div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="border border-gray-400 py-2">
                                    <div className="space-y-0 text-center">
                                      {treeFiltered ? (
                                        <div className="py-1 text-gray-800">
                                          ₹{(parseFloat(treeFiltered.tree_amount_valuer) || 0).toLocaleString()}
                                        </div>
                                      ) : (
                                        <div className="py-1 text-center text-gray-500">-</div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="border border-gray-400 py-2">
                                    <div className="space-y-0 text-center">
                                      {treeFiltered && record.treeRemarks[assetIndex] ? (
                                        <div className="py-1 text-gray-800">
                                          {record.treeRemarks[assetIndex]}
                                        </div>
                                      ) : (
                                        <div className="py-1 text-center text-gray-500">-</div>
                                      )}
                                    </div>
                                  </td>
                                </>
                              )}

                              {/* Consulting Agent Columns */}
                              {/* {selectedAgency === 'consulting_agent' && ( */}
                              {/* Data Entry */}
                              {(selectedAgency === 'consulting_agent' || selectedAgency === 'data_entry') && (
                                <>
                                  <td className="border border-gray-400 py-2">
                                    <div className="space-y-0 text-center">
                                      {record.propertyDescriptions[assetIndex] ? (
                                        <div className="py-1 text-gray-800">
                                          {record.propertyDescriptions[assetIndex]}
                                        </div>
                                      ) : (
                                        <div className="py-1 text-center text-gray-500">-</div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="border border-gray-400 py-2">
                                    <div className="space-y-0 text-center">
                                      {record.propertyAreas[assetIndex] ? (
                                        <div className="py-1 text-gray-800">
                                          {record.propertyAreas[assetIndex]}
                                        </div>
                                      ) : (
                                        <div className="py-1 text-center text-gray-500">-</div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="border border-gray-400 py-2">
                                    <div className="space-y-0 text-center">
                                      {record.propertyYears[assetIndex] ? (
                                        <div className="py-1 text-gray-800">
                                          {record.propertyYears[assetIndex]}
                                        </div>
                                      ) : (
                                        <div className="py-1 text-center text-gray-500">-</div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="border border-gray-400 py-2">
                                    <div className="space-y-0 text-center">
                                      {record.propertyActualAreas[assetIndex] ? (
                                        <div className="py-1 text-gray-800">
                                          {record.propertyActualAreas[assetIndex]}
                                        </div>
                                      ) : (
                                        <div className="py-1 text-center text-gray-500">-</div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="border border-gray-400 py-2">
                                    <div className="space-y-0 text-center">
                                      {record.propertyPaymentDue[assetIndex] ? (
                                        <div className="py-1 text-gray-800">
                                          {record.propertyPaymentDue[assetIndex]}
                                        </div>
                                      ) : (
                                        <div className="py-1 text-center text-gray-500">-</div>
                                      )}
                                    </div>
                                  </td>
                                  <td className="border border-gray-400 py-2">
                                    <div className="space-y-0 text-center">
                                      {record.propertyRemarks[assetIndex] ? (
                                        <div className="py-1 text-gray-800">
                                          {record.propertyRemarks[assetIndex]}
                                        </div>
                                      ) : (
                                        <div className="py-1 text-center text-gray-500">-</div>
                                      )}
                                    </div>
                                  </td>
                                </>
                              )}
                            </tr>
                          );
                        });
                      })}
                    </>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {filteredData.length > 0 && (
              <div className="bg-gray-50 px-6 py-3 border-t border-gray-200 flex justify-center">
                <div className="text-sm text-gray-600">
                  {translations[language].Showing} {filteredData.length} {translations[language].Records}
                  {searchTerm && ` matching "${searchTerm}"`}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Show message when filter mode is location but selection is incomplete */}
        {filterMode === "location" && !hasValidLocationSelection && (
          <div className="mt-6 text-center py-12">
            <div className="max-w-md mx-auto">
              <MapPin className="h-16 w-16 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-500 text-lg font-medium mb-2">
                {translations[language].LocationSelectionRequired}
              </p>
              <p className="text-gray-400 text-sm">
                {translations[language].PleaseSelectAtLeastDistrict}
              </p>
            </div>
          </div>
        )}
      </div>

      {showConfirmationModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
            <div className="flex items-center mb-4">
              <div className="bg-red-100 p-2 rounded-full mr-3">
                <svg
                  className="w-6 h-6 text-red-600"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8 3a1 1 0 100-2 1 1 0 000 2zm1-7H9v4h2V6z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-800">
                {translations[language].YouAreAboutToProceed}
              </h3>
            </div>
            <p className="text-sm text-gray-600 mb-6">
              {translations[language].DoYouReallyWantToContinuePendingSurveys}
            </p>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                onClick={() => setShowConfirmationModal(false)}
              >
                {translations[language].No}
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={() => {
                  setShowConfirmationModal(false);
                  if (onConfirmAction) onConfirmAction();
                }}
              >
                {translations[language].YesContinue}
              </button>
            </div>
          </div>
        </div>
      )}

      {showEditModal && editRecord && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              {/* Header */}
              <div className="flex justify-between items-center mb-6 gap-4">
                {/* Owner Name */}
                <div className="flex flex-col flex-1">
                  <label className="text-sm font-medium font-bold text-gray-700 mb-2">
                    {translations[language].OwnerName || 'भूधारकाचे नाव'}
                  </label>
                  <textarea
                    value={editRecord.owner_name || ''}
                    onChange={(e) => setEditRecord({ ...editRecord, owner_name: e.target.value })}
                    className="w-full border rounded px-2 py-1 resize-none"
                    rows={2}
                    disabled
                  />
                </div>

                {/* Survey Number */}
                <div className="flex flex-col flex-1">
                  <label className="text-sm font-medium font-bold text-gray-700 mb-2">
                    {translations[language].SurveyNo || 'गट/सर्व्हे क्रमांक'}
                  </label>
                  <input
                    type="text"
                    value={editRecord.survey_no || ''}
                    onChange={(e) => setEditRecord({ ...editRecord, survey_no: e.target.value })}
                    className="w-full border rounded px-2 py-1"
                    disabled
                  />
                </div>

                {/* Close Button */}
                <button
                  onClick={() => setShowEditModal(false)}
                  className="text-gray-400 hover:text-gray-600 mb-16"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              {/* Get visible columns for current agency */}
              {(() => {
                const visibleColumns = getVisibleColumns();

                // Create array of visible sections for dynamic grid
                const visibleSections = [];

                // Trees Section
                if (visibleColumns.tree) {
                  visibleSections.push(
                    <div key="tree" className="border rounded-lg p-4 bg-green-50">
                      <h4 className="font-semibold text-lg text-green-800 mb-3">
                        🌳{" "}
                        {selectedAgency === "agriculture"
                          ? "फळझाडे"
                          : selectedAgency === "forest"
                            ? "वनझाडे"
                            : translations[language].Tree}
                      </h4>

                      {(editRecord.tree || [])
                        .filter((tree) => {
                          if (selectedAgency === "agriculture") {
                            return tree.tree_type_name1 === "फळझाडे";
                          } else if (selectedAgency === "forest") {
                            return tree.tree_type_name1 === "वनझाडे";
                          }
                          return true;
                        })
                        .map((tree) => {
                          const originalIdx = editRecord.tree.findIndex(
                            (t) => t.tree_id === tree.tree_id
                          );

                          const currentTree = editRecord.tree[originalIdx];
                          const countVal = currentTree.tree_count ?? "";
                          const rateVal = currentTree.tree_value_valuer ?? "";

                          return (
                            <div
                              key={tree.tree_id}
                              className="grid grid-cols-6 gap-3 border rounded p-3 mb-2 bg-white items-center"
                            >
                              {/* Tree Type */}
                              <div className="col-span-1 font-medium">{tree.tree_type_name}</div>

                              {/* Count (editable text input) */}
                              <div className="flex flex-col">
                                <label className="text-xs text-gray-600">
                                  {translations[language].Compositenumber}
                                </label>
                                <input
                                  type="text"
                                  value={countVal}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const newTreeArr = [...(editRecord.tree || [])];
                                    newTreeArr[originalIdx] = {
                                      ...currentTree,
                                      tree_count: value,
                                    };
                                    setEditRecord({ ...editRecord, tree: newTreeArr });
                                  }}
                                  className="w-20 border rounded px-2 py-1"
                                  disabled
                                />
                              </div>

                              {/* Rate (editable text input with validation) */}
                              <div className="flex flex-col">
                                <label className="text-xs text-gray-600">
                                  {translations[language].Numberofactuals}
                                </label>
                                <input
                                  type="text"
                                  value={rateVal}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const parsedRate = parseFloat(value);
                                    const parsedCount = parseFloat(currentTree.tree_count) || 0;

                                    const newTreeArr = [...(editRecord.tree || [])];

                                    if (!isNaN(parsedRate) && parsedRate > parsedCount) {
                                      alert(`❌ प्रत्यक्षांची संख्या ही संयूक्तमोजणी संख्या जास्त असू शकत नाही (${parsedCount})`);
                                      // restore previous valid rate
                                      newTreeArr[originalIdx] = {
                                        ...currentTree,
                                        tree_value_valuer: rateVal,
                                      };
                                    } else {
                                      newTreeArr[originalIdx] = {
                                        ...currentTree,
                                        tree_value_valuer: value,
                                      };
                                    }

                                    setEditRecord({ ...editRecord, tree: newTreeArr });
                                  }}
                                  className="w-24 border rounded px-2 py-1"
                                />
                              </div>

                              {/* Total (manual text input) */}
                              <div className="flex flex-col">
                                <label className="text-xs text-gray-600">
                                  {translations[language].Paymentdue}
                                </label>
                                <input
                                  type="text"
                                  value={currentTree.tree_amount_valuer ?? ""}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const newTreeArr = [...(editRecord.tree || [])];
                                    newTreeArr[originalIdx] = {
                                      ...currentTree,
                                      tree_amount_valuer: value,
                                    };
                                    setEditRecord({ ...editRecord, tree: newTreeArr });
                                  }}
                                  className="w-24 border rounded px-2 py-1 font-bold text-green-700"
                                />
                              </div>

                              {/* Remarks when rate = 0 or empty */}
                              <div className="flex flex-col col-span-2">
                                {(!rateVal || rateVal === "0") && (
                                  <>
                                    <label className="text-xs text-gray-600">
                                      {translations[language].Remarks}
                                    </label>
                                    <input
                                      type="text"
                                      value={currentTree.remarks ?? ""}
                                      onChange={(e) => {
                                        const value = e.target.value;
                                        const newTreeArr = [...(editRecord.tree || [])];
                                        newTreeArr[originalIdx] = {
                                          ...currentTree,
                                          remarks: value,
                                        };
                                        setEditRecord({ ...editRecord, tree: newTreeArr });
                                      }}
                                      className="w-full border rounded px-2 py-1"
                                    />
                                  </>
                                )}
                              </div>

                              {/* Document */}
                              <div className="col-span-1">
                                {tree.document && (
                                  <button
                                    type="button"
                                    onClick={() => handleViewDocument(tree.document)}
                                    className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"
                                  >
                                    <Eye className="h-4 w-4" />
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  );
                }

                // Borewell Section
                if (visibleColumns.borewell) {
                  visibleSections.push(
                    <div key="borewell" className="border rounded-lg p-4 bg-indigo-50">
                      <h4 className="font-semibold text-lg text-indigo-800 mb-3">
                        ⚡ {translations[language].Borewell}
                      </h4>

                      {editRecord.borewell && editRecord.borewell.length > 0 ? (
                        editRecord.borewell.map((bw, idx) => {
                          const countVal = bw.total ?? "";
                          const rateVal = bw.actual_area ?? "";
                          const totalVal = bw.Property_amount_valuer ?? "";
                          const yearVal = bw.year_of_construction ?? "";

                          return (
                            <div
                              key={bw.Property_id || bw.borewell_id || idx}
                              className="border rounded p-3 mb-2 bg-white"
                            >
                              {/* Borewell label */}
                              <div className="font-medium mb-3">
                                {translations[language].Borewell} {idx + 1}
                              </div>

                              {/* First Row: Count and Rate */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Count (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Depthasperjointmeasurement}
                                  </label>
                                  <input
                                    type="text"
                                    value={countVal}
                                    onChange={(e) => {
                                      const newBW = [...editRecord.borewell];
                                      newBW[idx].total = e.target.value;
                                      setEditRecord({ ...editRecord, borewell: newBW });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                    disabled
                                  />
                                </div>

                                {/* Rate (editable text input with validation) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].actualDepth}
                                  </label>
                                  <input
                                    type="text"
                                    value={rateVal}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const parsedRate = parseFloat(value);
                                      const parsedCount = parseFloat(bw.total) || 0;

                                      const newBW = [...editRecord.borewell];

                                      if (!isNaN(parsedRate) && parsedRate > parsedCount) {
                                        alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`);
                                        // restore previous valid rate
                                        newBW[idx].actual_area = rateVal;
                                      } else {
                                        newBW[idx].actual_area = value;
                                      }

                                      setEditRecord({ ...editRecord, borewell: newBW });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Total and Year of Construction */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Total (manual text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Paymentdue}
                                  </label>
                                  <input
                                    type="text"
                                    value={totalVal}
                                    onChange={(e) => {
                                      const newBW = [...editRecord.borewell];
                                      newBW[idx].Property_amount_valuer = e.target.value;
                                      setEditRecord({ ...editRecord, borewell: newBW });
                                    }}
                                    className="w-full border rounded px-2 py-1 font-bold text-indigo-700"
                                  />
                                </div>

                                {/* Year of Construction (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Yearofexcavation}
                                  </label>
                                  <input
                                    type="text"
                                    value={yearVal}
                                    onChange={(e) => {
                                      const newBW = [...editRecord.borewell];
                                      newBW[idx].year_of_construction = e.target.value;
                                      setEditRecord({ ...editRecord, borewell: newBW });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Third Row: Actual Area and Remarks */}
                              <div className="grid grid-cols-2 gap-3 mb-3">

                                {/* Remarks when rate = 0 or empty */}
                                <div className="flex flex-col">
                                  {(!rateVal || rateVal === "0") && (
                                    <>
                                      <label className="text-xs text-gray-600 mb-1">
                                        {translations[language].Remarks}
                                      </label>
                                      <input
                                        type="text"
                                        value={bw.remarks ?? ""}
                                        onChange={(e) => {
                                          const newBW = [...editRecord.borewell];
                                          newBW[idx].remarks = e.target.value;
                                          setEditRecord({ ...editRecord, borewell: newBW });
                                        }}
                                        className="w-full border rounded px-2 py-1"
                                      />
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Document */}
                              <div className="flex justify-end">
                                {bw.document && (
                                  <button
                                    type="button"
                                    onClick={() => handleViewDocument(bw.document)}
                                    className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"
                                  >
                                    <Eye className="h-4 w-4" />
                                  </button>
                                )}
                              </div>

                            </div>
                          );
                        })
                      ) : (
                        <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">
                          {translations[language].NoDataAvailableForThisRecord ||
                            "No borewell data available for this record"}
                        </div>
                      )}
                    </div>
                  );
                }

                // Pipeline Section                
                if (visibleColumns.pipeline) {
                  visibleSections.push(
                    <div key="pipeline" className="border rounded-lg p-4 bg-red-50">
                      <h4 className="font-semibold text-lg text-red-800 mb-3">
                        🔧 {translations[language].pipeline}
                      </h4>

                      {editRecord.pipeline && editRecord.pipeline.length > 0 ? (
                        editRecord.pipeline.map((pipe, idx) => {
                          const countVal = pipe.total ?? "";
                          const rateVal = pipe.actual_area ?? "";
                          const totalVal = pipe.Property_amount_valuer ?? "";
                          const yearVal = pipe.year_of_construction ?? "";

                          return (
                            <div
                              key={pipe.Property_id || pipe.pipeline_id || idx}
                              className="border rounded p-3 mb-2 bg-white"
                            >
                              {/* Pipeline label */}
                              <div className="font-medium mb-3">
                                {translations[language].pipeline} {idx + 1}
                              </div>

                              {/* First Row: Count and Rate */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Count (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Lengthaccordingtojointmeasurement}
                                  </label>
                                  <input
                                    type="text"
                                    value={countVal}
                                    onChange={(e) => {
                                      const newPipe = [...editRecord.pipeline];
                                      newPipe[idx].total = e.target.value;
                                      setEditRecord({ ...editRecord, pipeline: newPipe });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                    disabled
                                  />
                                </div>

                                {/* Rate (editable text input with validation) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].actuallength}
                                  </label>
                                  <input
                                    type="text"
                                    value={rateVal}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const parsedRate = parseFloat(value);
                                      const parsedCount = parseFloat(pipe.total) || 0;

                                      const newPipe = [...editRecord.pipeline];

                                      if (!isNaN(parsedRate) && parsedRate > parsedCount) {
                                        alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`);
                                        // restore previous valid rate
                                        newPipe[idx].actual_area = rateVal;
                                      } else {
                                        newPipe[idx].actual_area = value;
                                      }

                                      setEditRecord({ ...editRecord, pipeline: newPipe });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Total and Year of Construction */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Total (manual text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Paymentdue}
                                  </label>
                                  <input
                                    type="text"
                                    value={totalVal}
                                    onChange={(e) => {
                                      const newPipe = [...editRecord.pipeline];
                                      newPipe[idx].Property_amount_valuer = e.target.value;
                                      setEditRecord({ ...editRecord, pipeline: newPipe });
                                    }}
                                    className="w-full border rounded px-2 py-1 font-bold text-red-700"
                                  />
                                </div>

                                {/* Year of Construction (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Yearofconstruction || "Year of Construction"}
                                  </label>
                                  <input
                                    type="text"
                                    value={yearVal}
                                    onChange={(e) => {
                                      const newPipe = [...editRecord.pipeline];
                                      newPipe[idx].year_of_construction = e.target.value;
                                      setEditRecord({ ...editRecord, pipeline: newPipe });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Third Row: Actual Area and Remarks */}
                              <div className="grid grid-cols-2 gap-3 mb-3">

                                {/* Remarks when rate = 0 or empty */}
                                <div className="flex flex-col">
                                  {(!rateVal || rateVal === "0") && (
                                    <>
                                      <label className="text-xs text-gray-600 mb-1">
                                        {translations[language].Remarks}
                                      </label>
                                      <input
                                        type="text"
                                        value={pipe.remarks ?? ""}
                                        onChange={(e) => {
                                          const newPipe = [...editRecord.pipeline];
                                          newPipe[idx].remarks = e.target.value;
                                          setEditRecord({ ...editRecord, pipeline: newPipe });
                                        }}
                                        className="w-full border rounded px-2 py-1"

                                      />
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Document */}
                              <div className="flex justify-end">
                                {pipe.document && (
                                  <button
                                    type="button"
                                    onClick={() => handleViewDocument(pipe.document)}
                                    className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"
                                  >
                                    <Eye className="h-4 w-4" />
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">
                          {translations[language].NoDataAvailableForThisRecord ||
                            "No pipeline data available for this record"}
                        </div>
                      )}
                    </div>
                  );
                }

                // Home Section                
                if (visibleColumns.home) {
                  visibleSections.push(
                    <div key="home" className="border rounded-lg p-4 bg-pink-50">
                      <h4 className="font-semibold text-lg text-pink-800 mb-3">
                        🏠 {translations[language].Home}
                      </h4>

                      {editRecord.home && editRecord.home.length > 0 ? (
                        editRecord.home.map((home, idx) => {
                          const countVal = home.total ?? "";
                          const rateVal = home.actual_area ?? "";
                          const totalVal = home.Property_amount_valuer ?? "";
                          const yearVal = home.year_of_construction ?? "";

                          return (
                            <div
                              key={home.Property_id || home.home_id || idx}
                              className="border rounded p-3 mb-2 bg-white"
                            >
                              {/* Home label with floor number */}
                              <div className="font-medium mb-3">
                                {translations[language].Home} {idx + 1} – {home.house_floor_no || "N/A"}
                              </div>

                              {/* First Row: Count and Rate */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Count (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Areaaccordingtocombinedcalculation}
                                  </label>
                                  <input
                                    type="text"
                                    value={countVal}
                                    onChange={(e) => {
                                      const newHome = [...editRecord.home];
                                      newHome[idx].total = e.target.value;
                                      setEditRecord({ ...editRecord, home: newHome });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                    disabled
                                  />
                                </div>

                                {/* Rate (editable text input with validation) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Agcactualarea}
                                  </label>
                                  <input
                                    type="text"
                                    value={rateVal}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const parsedRate = parseFloat(value);
                                      const parsedCount = parseFloat(home.total) || 0;

                                      const newHome = [...editRecord.home];

                                      if (!isNaN(parsedRate) && parsedRate > parsedCount) {
                                        alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`);
                                        // restore previous valid rate
                                        newHome[idx].actual_area = rateVal;
                                      } else {
                                        newHome[idx].actual_area = value;
                                      }

                                      setEditRecord({ ...editRecord, home: newHome });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Total and Year of Construction */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Total (manual text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Paymentdue}
                                  </label>
                                  <input
                                    type="text"
                                    value={totalVal}
                                    onChange={(e) => {
                                      const newHome = [...editRecord.home];
                                      newHome[idx].Property_amount_valuer = e.target.value;
                                      setEditRecord({ ...editRecord, home: newHome });
                                    }}
                                    className="w-full border rounded px-2 py-1 font-bold text-pink-700"
                                  />
                                </div>

                                {/* Year of Construction (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Yearofconstruction || "Year of Construction"}
                                  </label>
                                  <input
                                    type="text"
                                    value={yearVal}
                                    onChange={(e) => {
                                      const newHome = [...editRecord.home];
                                      newHome[idx].year_of_construction = e.target.value;
                                      setEditRecord({ ...editRecord, home: newHome });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Third Row: Actual Area and Remarks */}
                              <div className="grid grid-cols-2 gap-3 mb-3">

                                {/* Remarks when rate = 0 or empty */}
                                <div className="flex flex-col">
                                  {(!rateVal || rateVal === "0") && (
                                    <>
                                      <label className="text-xs text-gray-600 mb-1">
                                        {translations[language].Remarks}
                                      </label>
                                      <input
                                        type="text"
                                        value={home.remarks ?? ""}
                                        onChange={(e) => {
                                          const newHome = [...editRecord.home];
                                          newHome[idx].remarks = e.target.value;
                                          setEditRecord({ ...editRecord, home: newHome });
                                        }}
                                        className="w-full border rounded px-2 py-1"

                                      />
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Document */}
                              <div className="flex justify-end">
                                {home.document && (
                                  <button
                                    type="button"
                                    onClick={() => handleViewDocument(home.document)}
                                    className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"
                                  >
                                    <Eye className="h-4 w-4" />
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">
                          {translations[language].NoDataAvailableForThisRecord ||
                            "No home data available for this record"}
                        </div>
                      )}
                    </div>
                  );
                }

                // TinShed Section                
                if (visibleColumns.tinShed) {
                  visibleSections.push(
                    <div key="tinshed" className="border rounded-lg p-4 bg-amber-50">
                      <h4 className="font-semibold text-lg text-amber-800 mb-3">
                        🚚 {translations[language].TinShed}
                      </h4>

                      {editRecord["tinshed/godown"] && editRecord["tinshed/godown"].length > 0 ? (
                        editRecord["tinshed/godown"].map((shed, idx) => {
                          const countVal = shed.total ?? "";
                          const rateVal = shed.actual_area ?? "";
                          const totalVal = shed.Property_amount_valuer ?? "";
                          const yearVal = shed.year_of_construction ?? "";

                          return (
                            <div
                              key={shed.Property_id || shed.shed_id || idx}
                              className="border rounded p-3 mb-2 bg-white"
                            >
                              {/* Shed Label */}
                              <div className="font-medium mb-3">
                                {translations[language].TinShed} {idx + 1}
                              </div>

                              {/* First Row: Count and Rate */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Count (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Areaaccordingtocombinedcalculation}
                                  </label>
                                  <input
                                    type="text"
                                    value={countVal}
                                    onChange={(e) => {
                                      const newShed = [...editRecord["tinshed/godown"]];
                                      newShed[idx].total = e.target.value;
                                      setEditRecord({
                                        ...editRecord,
                                        ["tinshed/godown"]: newShed,
                                      });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                    disabled
                                  />
                                </div>

                                {/* Rate (editable text input with validation) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Agcactualarea}
                                  </label>
                                  <input
                                    type="text"
                                    value={rateVal}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const parsedRate = parseFloat(value);
                                      const parsedCount = parseFloat(shed.total) || 0;

                                      const newShed = [...editRecord["tinshed/godown"]];

                                      if (!isNaN(parsedRate) && parsedRate > parsedCount) {
                                        alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`);
                                        // restore previous valid rate
                                        newShed[idx].actual_area = rateVal;
                                      } else {
                                        newShed[idx].actual_area = value;
                                      }

                                      setEditRecord({
                                        ...editRecord,
                                        ["tinshed/godown"]: newShed,
                                      });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Total and Year of Construction */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Total (manual text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Paymentdue}
                                  </label>
                                  <input
                                    type="text"
                                    value={totalVal}
                                    onChange={(e) => {
                                      const newShed = [...editRecord["tinshed/godown"]];
                                      newShed[idx].Property_amount_valuer = e.target.value;
                                      setEditRecord({
                                        ...editRecord,
                                        ["tinshed/godown"]: newShed,
                                      });
                                    }}
                                    className="w-full border rounded px-2 py-1 font-bold text-amber-700"
                                  />
                                </div>

                                {/* Year of Construction (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Yearofconstruction || "Year of Construction"}
                                  </label>
                                  <input
                                    type="text"
                                    value={yearVal}
                                    onChange={(e) => {
                                      const newShed = [...editRecord["tinshed/godown"]];
                                      newShed[idx].year_of_construction = e.target.value;
                                      setEditRecord({
                                        ...editRecord,
                                        ["tinshed/godown"]: newShed,
                                      });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Third Row: Actual Area and Remarks */}
                              <div className="grid grid-cols-2 gap-3 mb-3">

                                {/* Remarks when rate = 0 or empty */}
                                <div className="flex flex-col">
                                  {(!rateVal || rateVal === "0") && (
                                    <>
                                      <label className="text-xs text-gray-600 mb-1">
                                        {translations[language].Remarks}
                                      </label>
                                      <input
                                        type="text"
                                        value={shed.remarks ?? ""}
                                        onChange={(e) => {
                                          const newShed = [...editRecord["tinshed/godown"]];
                                          newShed[idx].remarks = e.target.value;
                                          setEditRecord({
                                            ...editRecord,
                                            ["tinshed/godown"]: newShed,
                                          });
                                        }}
                                        className="w-full border rounded px-2 py-1"

                                      />
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Document */}
                              <div className="flex justify-end">
                                {shed.document && (
                                  <button
                                    type="button"
                                    onClick={() => handleViewDocument(shed.document)}
                                    className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"
                                  >
                                    <Eye className="h-4 w-4" />
                                  </button>
                                )}
                              </div>

                            </div>
                          );
                        })
                      ) : (
                        <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">
                          {translations[language].NoDataAvailableForThisRecord ||
                            "No tin shed data available for this record"}
                        </div>
                      )}
                    </div>
                  );
                }

                // Wire Section                
                if (visibleColumns.wire) {
                  visibleSections.push(
                    <div key="wire" className="border rounded-lg p-4 bg-blue-50">
                      <h4 className="font-semibold text-lg text-blue-800 mb-3">
                        🪢 {translations[language].AgWirefencing}
                      </h4>

                      {editRecord.wirefencing && editRecord.wirefencing.length > 0 ? (
                        editRecord.wirefencing.map((wire, idx) => {
                          const countVal = wire.total ?? "";
                          const rateVal = wire.actual_area ?? "";
                          const totalVal = wire.Property_amount_valuer ?? "";
                          const yearVal = wire.year_of_construction ?? "";

                          return (
                            <div
                              key={wire.Property_id || wire.wire_id || idx}
                              className="border rounded p-3 mb-2 bg-white"
                            >
                              {/* Wirefencing label */}
                              <div className="font-medium mb-3">
                                {translations[language].AgWirefencing} {idx + 1}
                              </div>

                              {/* First Row: Count and Rate */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Count (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Areaaccordingtocombinedcalculation}
                                  </label>
                                  <input
                                    type="text"
                                    value={countVal}
                                    onChange={(e) => {
                                      const newWire = [...editRecord.wirefencing];
                                      newWire[idx].total = e.target.value;
                                      setEditRecord({
                                        ...editRecord,
                                        wirefencing: newWire,
                                      });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                    disabled
                                  />
                                </div>

                                {/* Rate (editable text input with validation) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].lengthheight}
                                  </label>
                                  <input
                                    type="text"
                                    value={rateVal}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const parsedRate = parseFloat(value);
                                      const parsedCount = parseFloat(wire.total) || 0;

                                      const newWire = [...editRecord.wirefencing];

                                      if (!isNaN(parsedRate) && parsedRate > parsedCount) {
                                        alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`);
                                        // restore previous valid rate
                                        newWire[idx].actual_area = rateVal;
                                      } else {
                                        newWire[idx].actual_area = value;
                                      }

                                      setEditRecord({
                                        ...editRecord,
                                        wirefencing: newWire,
                                      });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Total and Year of Construction */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Total (manual text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Paymentdue}
                                  </label>
                                  <input
                                    type="text"
                                    value={totalVal}
                                    onChange={(e) => {
                                      const newWire = [...editRecord.wirefencing];
                                      newWire[idx].Property_amount_valuer = e.target.value;
                                      setEditRecord({
                                        ...editRecord,
                                        wirefencing: newWire,
                                      });
                                    }}
                                    className="w-full border rounded px-2 py-1 font-bold text-blue-700"
                                  />
                                </div>

                                {/* Year of Construction (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Yearofconstruction || "Year of Construction"}
                                  </label>
                                  <input
                                    type="text"
                                    value={yearVal}
                                    onChange={(e) => {
                                      const newWire = [...editRecord.wirefencing];
                                      newWire[idx].year_of_construction = e.target.value;
                                      setEditRecord({
                                        ...editRecord,
                                        wirefencing: newWire,
                                      });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Third Row: Actual Area and Remarks */}
                              <div className="grid grid-cols-2 gap-3 mb-3">

                                {/* Remarks when rate = 0 or empty */}
                                <div className="flex flex-col">
                                  {(!rateVal || rateVal === "0") && (
                                    <>
                                      <label className="text-xs text-gray-600 mb-1">
                                        {translations[language].Remarks}
                                      </label>
                                      <input
                                        type="text"
                                        value={wire.remarks ?? ""}
                                        onChange={(e) => {
                                          const newWire = [...editRecord.wirefencing];
                                          newWire[idx].remarks = e.target.value;
                                          setEditRecord({
                                            ...editRecord,
                                            wirefencing: newWire,
                                          });
                                        }}
                                        className="w-full border rounded px-2 py-1"

                                      />
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Document */}
                              <div className="flex justify-end">
                                {wire.document && (
                                  <button
                                    type="button"
                                    onClick={() => handleViewDocument(wire.document)}
                                    className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"
                                  >
                                    <Eye className="h-4 w-4" />
                                  </button>
                                )}
                              </div>

                            </div>
                          );
                        })
                      ) : (
                        <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">
                          {translations[language].NoDataAvailableForThisRecord ||
                            "No wirefencing data available for this record"}
                        </div>
                      )}
                    </div>
                  );
                }

                // Well Section
                if (visibleColumns.well) {
                  visibleSections.push(
                    <div key="well" className="border rounded-lg p-4 bg-teal-50">
                      <h4 className="font-semibold text-lg text-teal-800 mb-3">
                        ⛲ {translations[language].Well}
                      </h4>

                      {editRecord.well && editRecord.well.length > 0 ? (
                        editRecord.well.map((wl, idx) => {
                          const countVal = wl.total ?? "";
                          const rateVal = wl.actual_area ?? "";
                          const totalVal = wl.Property_amount_valuer ?? "";
                          const yearVal = wl.year_of_construction ?? "";

                          return (
                            <div
                              key={wl.Property_id || wl.well_id || idx}
                              className="border rounded p-3 mb-2 bg-white"
                            >
                              {/* Well label */}
                              <div className="font-medium mb-3">
                                {translations[language].Well} {idx + 1}
                              </div>

                              {/* First Row: Count and Rate */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Count */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Volumeasperjointmeasurement}
                                  </label>
                                  <input
                                    type="text"
                                    value={countVal}
                                    onChange={(e) => {
                                      const newWell = [...editRecord.well];
                                      newWell[idx].total = e.target.value;
                                      setEditRecord({ ...editRecord, well: newWell });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                    disabled
                                  />
                                </div>

                                {/* Rate with validation */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].ActualVolume}
                                  </label>
                                  <input
                                    type="text"
                                    value={rateVal}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const parsedRate = parseFloat(value);
                                      const parsedCount = parseFloat(wl.total) || 0;

                                      const newWell = [...editRecord.well];

                                      if (!isNaN(parsedRate) && parsedRate > parsedCount) {
                                        alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`);
                                        newWell[idx].actual_area = rateVal;
                                      } else {
                                        newWell[idx].actual_area = value;
                                      }

                                      setEditRecord({ ...editRecord, well: newWell });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Total and Year of Construction */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Total (manual input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Paymentdue}
                                  </label>
                                  <input
                                    type="text"
                                    value={totalVal}
                                    onChange={(e) => {
                                      const newWell = [...editRecord.well];
                                      newWell[idx].Property_amount_valuer = e.target.value;
                                      setEditRecord({ ...editRecord, well: newWell });
                                    }}
                                    className="w-full border rounded px-2 py-1 font-bold text-teal-700"
                                  />
                                </div>

                                {/* Year of Construction (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Yearofexcavation}
                                  </label>
                                  <input
                                    type="text"
                                    value={yearVal}
                                    onChange={(e) => {
                                      const newWell = [...editRecord.well];
                                      newWell[idx].year_of_construction = e.target.value;
                                      setEditRecord({ ...editRecord, well: newWell });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Third Row: Actual Area and Remarks */}
                              <div className="grid grid-cols-2 gap-3 mb-3">

                                {/* Remarks when rate = 0 or empty */}
                                <div className="flex flex-col">
                                  {(!rateVal || rateVal === "0") && (
                                    <>
                                      <label className="text-xs text-gray-600 mb-1">
                                        {translations[language].Remarks}
                                      </label>
                                      <input
                                        type="text"
                                        value={wl.remarks ?? ""}
                                        onChange={(e) => {
                                          const newWell = [...editRecord.well];
                                          newWell[idx].remarks = e.target.value;
                                          setEditRecord({ ...editRecord, well: newWell });
                                        }}
                                        className="w-full border rounded px-2 py-1"

                                      />
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Document */}
                              <div className="flex justify-end">
                                {wl.document && (
                                  <button
                                    type="button"
                                    onClick={() => handleViewDocument(wl.document)}
                                    className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"
                                  >
                                    <Eye className="h-4 w-4" />
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">
                          {translations[language].NoDataAvailableForThisRecord ||
                            "No well data available for this record"}
                        </div>
                      )}
                    </div>
                  );
                }

                //Farmpond Section
                if (visibleColumns.farmpond) {
                  visibleSections.push(
                    <div key="farmpond" className="border rounded-lg p-4 bg-blue-50">
                      <h4 className="font-semibold text-lg text-blue-800 mb-3">
                        🏞️ {translations[language].AgFarmpond}
                      </h4>

                      {editRecord.farmpond && editRecord.farmpond.length > 0 ? (
                        editRecord.farmpond.map((pond, idx) => {
                          const countVal = pond.total ?? "";
                          const rateVal = pond.actual_area ?? "";
                          const totalVal = pond.Property_amount_valuer ?? "";
                          const yearVal = pond.year_of_construction ?? "";

                          return (
                            <div
                              key={pond.Property_id || pond.farmpond_id || idx}
                              className="border rounded p-3 mb-2 bg-white"
                            >
                              {/* Farmpond label */}
                              <div className="font-medium mb-3">
                                {translations[language].AgFarmpond} {idx + 1}
                              </div>

                              {/* First Row: Count and Rate */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Count (disabled text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Volumeasperjointmeasurement}
                                  </label>
                                  <input
                                    type="text"
                                    value={countVal}
                                    onChange={(e) => {
                                      const newPond = [...editRecord.farmpond];
                                      newPond[idx].total = e.target.value;
                                      setEditRecord({ ...editRecord, farmpond: newPond });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                    disabled
                                  />
                                </div>

                                {/* Rate with validation */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].ActualVolume}
                                  </label>
                                  <input
                                    type="text"
                                    value={rateVal}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const parsedRate = parseFloat(value);
                                      const parsedCount = parseFloat(pond.total) || 0;

                                      const newPond = [...editRecord.farmpond];

                                      if (!isNaN(parsedRate) && parsedRate > parsedCount) {
                                        alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`);
                                        newPond[idx].actual_area = rateVal;
                                      } else {
                                        newPond[idx].actual_area = value;
                                      }

                                      setEditRecord({ ...editRecord, farmpond: newPond });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Total and Year of Construction */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Total (manual text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Paymentdue}
                                  </label>
                                  <input
                                    type="text"
                                    value={totalVal}
                                    onChange={(e) => {
                                      const newPond = [...editRecord.farmpond];
                                      newPond[idx].Property_amount_valuer = e.target.value;
                                      setEditRecord({ ...editRecord, farmpond: newPond });
                                    }}
                                    className="w-full border rounded px-2 py-1 font-bold text-blue-700"
                                  />
                                </div>

                                {/* Year of Construction (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Yearofconstruction || "Year of Construction"}
                                  </label>
                                  <input
                                    type="text"
                                    value={yearVal}
                                    onChange={(e) => {
                                      const newPond = [...editRecord.farmpond];
                                      newPond[idx].year_of_construction = e.target.value;
                                      setEditRecord({ ...editRecord, farmpond: newPond });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Third Row: Actual Area and Remarks */}
                              <div className="grid grid-cols-2 gap-3 mb-3">

                                {/* Remarks when rate = 0 or empty */}
                                <div className="flex flex-col">
                                  {(!rateVal || rateVal === "0") && (
                                    <>
                                      <label className="text-xs text-gray-600 mb-1">
                                        {translations[language].Remarks}
                                      </label>
                                      <input
                                        type="text"
                                        value={pond.remarks ?? ""}
                                        onChange={(e) => {
                                          const newPond = [...editRecord.farmpond];
                                          newPond[idx].remarks = e.target.value;
                                          setEditRecord({ ...editRecord, farmpond: newPond });
                                        }}
                                        className="w-full border rounded px-2 py-1"

                                      />
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Document */}
                              <div className="flex justify-end">
                                {pond.document && (
                                  <button
                                    type="button"
                                    onClick={() => handleViewDocument(pond.document)}
                                    className="px-3 py-1 bg-blue-600 text-white rounded-lg text-sm hover:bg-blue-700 flex items-center gap-1"
                                  >
                                    <Eye className="h-4 w-4" />
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">
                          {translations[language].NoDataAvailableForThisRecord ||
                            "No farmpond data available for this record"}
                        </div>
                      )}
                    </div>
                  );
                }

                // Other Asset Section
                if (visibleColumns.otherAsset) {
                  visibleSections.push(
                    <div key="other" className="border rounded-lg p-4 bg-purple-50">
                      <h4 className="font-semibold text-lg text-purple-800 mb-3">
                        🛠️ {translations[language].NewOtherAsset || "Other Asset"}
                      </h4>

                      {editRecord.other && editRecord.other.length > 0 ? (
                        editRecord.other.map((asset, idx) => {
                          const countVal = asset.total ?? asset.Property_count ?? "";
                          const rateVal = asset.actual_area ?? "";
                          const totalVal = asset.Property_amount_valuer ?? "";
                          const yearVal = asset.year_of_construction ?? "";

                          return (
                            <div
                              key={asset.Property_id || idx}
                              className="border rounded p-3 mb-2 bg-white"
                            >
                              {/* Asset Label */}
                              <div className="font-medium mb-3">
                                {translations[language].NewOtherAsset || "Other Asset"} {idx + 1}
                              </div>

                              {/* First Row: Count and Rate */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Count */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Areaaccordingtocombinedcalculation}
                                  </label>
                                  <input
                                    type="text"
                                    value={countVal}
                                    onChange={(e) => {
                                      const newAssets = [...editRecord.other];
                                      newAssets[idx].total = e.target.value;
                                      setEditRecord({ ...editRecord, other: newAssets });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                    disabled
                                  />
                                </div>

                                {/* Rate with validation */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Agcactualarea}
                                  </label>
                                  <input
                                    type="text"
                                    value={rateVal}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const parsedRate = parseFloat(value);
                                      const parsedCount = parseFloat(asset.total || asset.Property_count) || 0;

                                      const newAssets = [...editRecord.other];

                                      if (!isNaN(parsedRate) && parsedRate > parsedCount) {
                                        alert(`❌ संयुक्त गणनेनुसार प्रत्यक्ष क्षेत्रफळ हे एकूण क्षेत्रफळापेक्षा जास्त असू शकत नाही (${parsedCount})`);
                                        newAssets[idx].actual_area = rateVal;
                                      } else {
                                        newAssets[idx].actual_area = value;
                                      }

                                      setEditRecord({ ...editRecord, other: newAssets });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Second Row: Total and Year of Construction */}
                              <div className="grid grid-cols-2 gap-3 mb-3">
                                {/* Total (manual input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Paymentdue}
                                  </label>
                                  <input
                                    type="text"
                                    value={totalVal}
                                    onChange={(e) => {
                                      const newAssets = [...editRecord.other];
                                      newAssets[idx].Property_amount_valuer = e.target.value;
                                      setEditRecord({ ...editRecord, other: newAssets });
                                    }}
                                    className="w-full border rounded px-2 py-1 font-bold text-purple-700"
                                  />
                                </div>

                                {/* Year of Construction (editable text input) */}
                                <div className="flex flex-col">
                                  <label className="text-xs text-gray-600 mb-1">
                                    {translations[language].Yearofexcavation}
                                  </label>
                                  <input
                                    type="text"
                                    value={yearVal}
                                    onChange={(e) => {
                                      const newAssets = [...editRecord.other];
                                      newAssets[idx].year_of_construction = e.target.value;
                                      setEditRecord({ ...editRecord, other: newAssets });
                                    }}
                                    className="w-full border rounded px-2 py-1"
                                  />
                                </div>
                              </div>

                              {/* Third Row: Actual Area and Remarks */}
                              <div className="grid grid-cols-2 gap-3 mb-3">

                                {/* Remarks when rate = 0 or empty */}
                                <div className="flex flex-col">
                                  {(!rateVal || rateVal === "0") && (
                                    <>
                                      <label className="text-xs text-gray-600 mb-1">
                                        {translations[language].Remarks}
                                      </label>
                                      <input
                                        type="text"
                                        value={asset.remarks ?? ""}
                                        onChange={(e) => {
                                          const newAssets = [...editRecord.other];
                                          newAssets[idx].remarks = e.target.value;
                                          setEditRecord({ ...editRecord, other: newAssets });
                                        }}
                                        className="w-full border rounded px-2 py-1"

                                      />
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Document */}
                              <div className="flex justify-end">
                                {asset.document && (
                                  <button
                                    type="button"
                                    onClick={() => handleViewDocument(asset.document)}
                                    className="px-3 py-1 bg-purple-600 text-white rounded-lg text-sm hover:bg-purple-700 flex items-center gap-1"
                                  >
                                    <Eye className="h-4 w-4" />
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="p-4 bg-gray-100 rounded-lg text-center text-gray-600">
                          {translations[language].NoDataAvailableForThisRecord ||
                            "No other asset data available"}
                        </div>
                      )}
                    </div>
                  );
                }

                // Dynamic grid - maximum 2 columns
                const gridCols = visibleSections.length === 1 ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2';

                return (
                  <div className="space-y-6">
                    {/* Dynamic Grid for visible sections */}
                    <div className={`grid ${gridCols} gap-6`}>
                      {visibleSections}
                    </div>
                  </div>
                );
              })()}

              {/* Save Button */}
              <button
                className={`mt-6 px-6 py-2 rounded-lg text-white flex items-center justify-center gap-2 ${isSaving ? "bg-green-400 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"
                  }`}
                disabled={isSaving}
                onClick={async () => {
                  try {
                    setIsSaving(true);
                    const visibleColumns = getVisibleColumns();

                    // Save Trees
                    if (visibleColumns.tree && editRecord.tree?.length > 0) {
                      for (let tree of editRecord.tree) {
                        const payload = {
                          tree_count: tree.tree_count,
                          tree_value_valuer: tree.tree_value_valuer,
                          tree_amount_valuer: tree.tree_amount_valuer,
                          remarks: tree.remarks,
                        };
                        await apiService.patchUpdateHighwayTree(tree.tree_id, payload);
                      }
                    }

                    // Save Wells
                    if (visibleColumns.well && editRecord.well?.length > 0) {
                      for (let wl of editRecord.well) {
                        const payload = {
                          Property_value_valuer: wl.Property_value_valuer,
                          property_type: wl.property_type,
                          Property_amount_valuer: wl.Property_amount_valuer,
                          remarks: wl.remarks,
                          year_of_construction: wl.year_of_construction,
                          actual_area: wl.actual_area
                        };
                        await apiService.patchUpdateHighwayProperty(wl.Property_id, payload);
                      }
                    }

                    // Save Homes
                    if (visibleColumns.home && editRecord.home?.length > 0) {
                      for (let home of editRecord.home) {
                        const payload = {
                          Property_value_valuer: home.Property_value_valuer,
                          property_type: home.property_type,
                          house_floor_no: home.house_floor_no,
                          Property_amount_valuer: home.Property_amount_valuer,
                          remarks: home.remarks,
                          year_of_construction: home.year_of_construction,
                          actual_area: home.actual_area
                        };
                        await apiService.patchUpdateHighwayProperty(home.Property_id, payload);
                      }
                    }

                    // Save Tinshed
                    if (visibleColumns.tinShed && editRecord["tinshed/godown"]?.length > 0) {
                      for (let shed of editRecord["tinshed/godown"]) {
                        const payload = {
                          Property_value_valuer: shed.Property_value_valuer,
                          property_type: shed.property_type,
                          house_floor_no: shed.house_floor_no,
                          Property_amount_valuer: shed.Property_amount_valuer,
                          remarks: shed.remarks,
                          year_of_construction: shed.year_of_construction,
                          actual_area: shed.actual_area
                        };
                        await apiService.patchUpdateHighwayProperty(shed.Property_id, payload);
                      }
                    }

                    // Save Wirefencing
                    if (visibleColumns.wire && editRecord.wirefencing?.length > 0) {
                      for (let wire of editRecord.wirefencing) {
                        const payload = {
                          property_type: wire.property_type,
                          Property_value_valuer: wire.Property_value_valuer,
                          Property_amount_valuer: wire.Property_amount_valuer,
                          remarks: wire.remarks,
                          year_of_construction: wire.year_of_construction,
                          actual_area: wire.actual_area
                        };
                        await apiService.patchUpdateHighwayProperty(wire.Property_id, payload);
                      }
                    }

                    // Save Farmpond
                    if (visibleColumns.farmpond && editRecord.farmpond?.length > 0) {
                      for (let farmpond of editRecord.farmpond) {
                        const payload = {
                          Property_value_valuer: farmpond.Property_value_valuer,
                          property_type: farmpond.property_type,
                          Property_amount_valuer: farmpond.Property_amount_valuer,
                          remarks: farmpond.remarks,
                          year_of_construction: farmpond.year_of_construction,
                          actual_area: farmpond.actual_area
                        };

                        await apiService.patchUpdateHighwayProperty(farmpond.Property_id, payload);
                      }
                    }

                    // Save Borewell
                    if (visibleColumns.borewell && editRecord.borewell?.length > 0) {
                      for (let borewell of editRecord.borewell) {
                        const payload = {
                          property_value_valuer: borewell.Property_value_valuer,
                          property_type: borewell.property_type,
                          Property_amount_valuer: borewell.Property_amount_valuer,
                          remarks: borewell.remarks,
                          year_of_construction: borewell.year_of_construction,
                          actual_area: borewell.actual_area
                        };
                        await apiService.patchUpdateHighwayProperty(borewell.Property_id, payload);
                      }
                    }

                    // Save Pipeline
                    if (visibleColumns.pipeline && editRecord.pipeline?.length > 0) {
                      for (let pipeline of editRecord.pipeline) {
                        const payload = {
                          property_value_valuer: pipeline.Property_value_valuer,
                          property_type: pipeline.property_type,
                          Property_amount_valuer: pipeline.Property_amount_valuer,
                          remarks: pipeline.remarks,
                          year_of_construction: pipeline.year_of_construction,
                          actual_area: pipeline.actual_area
                        };
                        await apiService.patchUpdateHighwayProperty(pipeline.Property_id, payload);
                      }
                    }

                    // Save Other Assets
                    if (visibleColumns.otherAsset && editRecord.other?.length > 0) {
                      for (let asset of editRecord.other) {
                        const payload = {
                          property_value_valuer: asset.Property_value_valuer,
                          property_type: asset.property_type,
                          Property_amount_valuer: asset.Property_amount_valuer,
                          remarks: asset.remarks,
                          year_of_construction: asset.year_of_construction,
                          actual_area: asset.actual_area
                        };

                        await apiService.patchUpdateHighwayProperty(asset.Property_id, payload);
                      }
                    }

                    // Show success and refresh data
                    setSuccess(true);
                    setSuccessMessage("Updated Successfully");
                    setShowEditModal(false);
                    await loadCompensationData(); // Refresh the main table

                    // Auto-hide success message
                    setTimeout(() => {
                      setSuccess(false);
                      setSuccessMessage('');
                    }, 4000);

                  } catch (error) {
                    console.error("Update failed:", error);
                    setError(`${translations[language].FailedToUpdate}: ${error.message}`);
                  } finally {
                    setIsSaving(false);
                  }
                }}
              >
                {isSaving ? (
                  <>
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8z"
                      ></path>
                    </svg>
                    {translations[language].Saving}...
                  </>
                ) : (
                  <>
                    <Save className="w-5 h-5" />
                    {translations[language].SaveChanges}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Document Viewer Modal */}
      {showDocumentViewer && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl w-full max-w-6xl h-[95vh] shadow-2xl overflow-hidden border border-gray-200">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
              <div className="flex items-center space-x-3">
                <h3 className="text-2xl font-bold text-gray-800 tracking-tight">
                  {translations[language]?.DocumentPreview || 'Document Preview'}
                </h3>
              </div>
              <button
                onClick={closeDocumentViewer}
                className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 transition-all duration-200 flex items-center justify-center text-xl font-bold shadow-sm hover:shadow-md"
                aria-label="Close modal"
              >
                <X className="h-6 w-6" />
              </button>
            </div>

            {/* Document Viewer Container */}
            <div className="h-[calc(95vh-80px)] flex flex-col">
              <div className="flex-1 bg-gray-50 overflow-hidden shadow-inner border border-gray-200">
                {/* Document Content */}
                <div className="w-full h-full flex items-center justify-center">
                  {isPDFToView ? (
                    <iframe
                      src={fileUrlToView}
                      className="w-full h-full border-0 bg-white shadow-lg"
                      title="PDF Preview"
                    />
                  ) : (
                    <img
                      src={fileUrlToView}
                      alt="Document"
                      className="w-full h-auto object-contain shadow-lg"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default HighwayConcernValuer;